import React, { useEffect, useRef, useState } from 'react';
import { useImperativeHandle } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import EntryBase from '../../components/EntryBase';
import EntryGridAr from '../../components/EntryGridAr';
import EntryLayout from '../../components/EntryLayout';
import EntrySetting from '../../components/EntrySetting';
import { CellType, GetDesitRound, NumConv } from '../../modules/appLibrary';
import { warnmsg } from '../../modules/msgboxstore';
import { addentrylayout, setentrylayout, setentrystartup } from '../../modules/toolpanelstore';

const COMMON_ENTRY_PANEL_TYPES = [
    "103",
    "100",
    "101",
    "102",
    "104",
];

const MATERIAL_PANEL_TYPES = {
    "0": { detail: "110", total: "111" },    
    "1": { detail: "120", total: "121" },
    "2": { detail: "130", total: "131" },
};

const REFERENCE_SOURCE_SLIP_TYPES = {
    "1": "01",
    "2": "02",
    "3": "02",
};
const RAW_SALES_REFERENCE_SOURCE_OPTION = {
    code: "3",
    name: "原材料売上（海外有償支給）",
};

const TOTAL_DETAIL_SUMMARY_TYPES = {
    "111": { detail: "110", quantityColumn: "ZSKM_SIKYUMETERSU" },
    "121": { detail: "120", quantityColumn: "ZSKM_SIKYUSU" },
    "131": { detail: "130", quantityColumn: "ZSKM_SIKYUSU" },
};

const DETAIL_PANEL_TYPES = ["110", "120", "130"];
const MATERIAL_DETAIL_TABLE = "D_ZSKM";
const NON_PHYSICAL_DETAIL_COLUMNS = ["ZSKM_SIIRE", "ZSKM_STOCK"];
const DETAIL_REFERENCE_LOCK_COLUMNS = ["ZSKM_ZAIHINBAN", "ZSKM_ZAICOLORCD"];
const ACCESSORY_REFERENCE_LOCK_COLUMNS = [
    "ZSKM_ZAISIIRESAKIKBN",
    "ZSKM_ZAISIIRESAKICD",
    "ZSKM_ZAISIIRESAKISUBCD",
    "ZSKM_ZAISIIRESAKICD_NM",
    "ZSKM_MEKERCOLORNO",
    "ZSKM_MEKERCOLORNO_NM",
    "FZK_SIREFUZOKU_HBN",
    "FZK_FUZOKU_SIZE",
    "FZK_SIREFUZOKU_SIZE",
    "ZSKM_HEIKINTANKA",
];
const SUBMATERIAL_REFERENCE_LOCK_COLUMNS = [
    "ZSKM_ZAISIIRESAKIKBN",
    "ZSKM_ZAISIIRESAKICD",
    "ZSKM_ZAISIIRESAKISUBCD",
    "ZSKM_ZAISIIRESAKICD_NM",
    "ZSKM_MEKERCOLORNO",
    "ZSKM_MEKERCOLORNO_NM",
    "FZK_SIREFUZOKU_HBN",
    "ZSKM_HEIKINTANKA",
];
const MATERIAL_DETAIL_PANEL_TYPE = "110";
const ACCESSORY_DETAIL_PANEL_TYPE = "120";
const SUBMATERIAL_DETAIL_PANEL_TYPE = "130";
const MATERIAL_ITEM_NUMBER_COLUMN = "ZSKM_ZAIHINBAN";
const MATERIAL_COLOR_COLUMN = "ZSKM_ZAICOLORCD";
const MATERIAL_SUPPLIER_CODE_COLUMN = "ZSKM_ZAISIIRESAKICD";
const MATERIAL_MAKER_ITEM_NUMBER_COLUMN = "ZAI_MEKERHBN";
const MATERIAL_SELECTION_FIELD_MAP = [
    ["ZAI_TORKUBUN", "ZSKM_ZAISIIRESAKIKBN"],
    ["ZAI_TORSUBCODE", "ZSKM_ZAISIIRESAKISUBCD"],
    ["ZAI_MEKERHBN", MATERIAL_MAKER_ITEM_NUMBER_COLUMN],
];
const YEN_UNIT_PRICE_COLUMN = "ZSKM_TANKA";
const FOREIGN_CURRENCY_UNIT_PRICE_COLUMN = "ZSKM_TANKAF";
const DETAIL_AMOUNT_COLUMNS = [
    YEN_UNIT_PRICE_COLUMN,
    FOREIGN_CURRENCY_UNIT_PRICE_COLUMN,
    "ZSKM_KINGAKU",
    "ZSKM_KINGAKUF",
    "ZSKM_KINGAKUZ",
];
const MATERIAL_SELECTION_CLEAR_COLUMNS = [
    MATERIAL_COLOR_COLUMN,
    MATERIAL_COLOR_COLUMN + "_cd",
    MATERIAL_COLOR_COLUMN + "_nm",
    "ZSKM_MEKERCOLORNO",
    "ZSKM_MEKERCOLORNO_nm",
    "ZAI_KIKAKUE",
    "ZSKM_HEIKINTANKA",
    ...DETAIL_AMOUNT_COLUMNS,
    "ZSKM_SIKYUTANSU",
];
const DIRECT_MATERIAL_SELECTION_CLEAR_COLUMNS = [
    MATERIAL_MAKER_ITEM_NUMBER_COLUMN,
    ...MATERIAL_SELECTION_CLEAR_COLUMNS,
];
const MATERIAL_COLOR_CLEAR_COLUMNS = [
    "ZSKM_MEKERCOLORNO",
    "ZSKM_MEKERCOLORNO_nm",
    "ZSKM_HEIKINTANKA",
    ...DETAIL_AMOUNT_COLUMNS,
];
const ACCESSORY_SELECTION_CLEAR_COLUMNS = [
    MATERIAL_COLOR_COLUMN,
    MATERIAL_COLOR_COLUMN + "_cd",
    MATERIAL_COLOR_COLUMN + "_nm",
    "ZSKM_MEKERCOLORNO",
    "ZSKM_MEKERCOLORNO_nm",
    "ZSKM_HEIKINTANKA",
    ...DETAIL_AMOUNT_COLUMNS,
];
const SUBMATERIAL_SELECTION_CLEAR_COLUMNS = [
    MATERIAL_COLOR_COLUMN,
    MATERIAL_COLOR_COLUMN + "_cd",
    MATERIAL_COLOR_COLUMN + "_nm",
    "ZSKM_MEKERCOLORNO",
    "ZSKM_MEKERCOLORNO_nm",
    "ZSKM_HEIKINTANKA",
    ...DETAIL_AMOUNT_COLUMNS,
];
const ACCESSORY_COLOR_CLEAR_COLUMNS = [
    "ZSKM_HEIKINTANKA",
    ...DETAIL_AMOUNT_COLUMNS,
];
const SUBMATERIAL_COLOR_CLEAR_COLUMNS = [
    "ZSKM_HEIKINTANKA",
    ...DETAIL_AMOUNT_COLUMNS,
];
const FZK_SELECTION_CLEAR_COLUMNS = [
    "FZK_FUZOKU_NM",
    "FZK_SIREFUZOKU_HBN",
    "FZK_FUZOKU_SIZE",
    "FZK_SIREFUZOKU_SIZE",
    "ZSKM_ZAISIZECD",
    "ZSKM_TANI",
    ...ACCESSORY_SELECTION_CLEAR_COLUMNS,
];
const FZK_COLOR_CLEAR_COLUMNS = [
    MATERIAL_COLOR_COLUMN + "_nm",
    "ZSKM_MEKERCOLORNO",
    "ZSKM_MEKERCOLORNO_nm",
];
const CONDITIONAL_LOCK_PANEL_TYPES = ["100", "101", "102", "104"];
const SLIP_TYPE_COLUMNS = ["ZSK_DENSYUBETU", "ZSKM_DENSYUBETU"];
const SUPPLY_SOURCE_COLUMNS = [
    "ZSK_SIKYUMOTOCD",
    "ZSK_BRDCD",
    "ZSK_SOKOKBN",
    "ZSK_SOKOCD",
    "ZSK_SOKOSUBCD",
];
const SUPPLY_SOURCE_NAME_COLUMNS = [
    "ZSK_SIKYUMOTOCD_nm",
    "ZSK_BRDCD_nm",
    "ZSK_SOKOKBN_nm",
    "ZSK_SOKOCD_nm",
    "ZSK_SOKOSUBCD_nm",
];
const INVOICE_COLUMNS = ["ZSK_INVOICENO", "ZSK_INVOICEEDA"];
const INVOICE_INPUT_LENGTHS = {
    "ZSK_INVOICENO": 20,
    "ZSK_INVOICEEDA": 4,
};
const TOTAL_VALUE_COLUMNS = [
    "ZSK_QTY_T",
    "ZSK_ZEIGAKU",
    "ZSK_AMT_T",
    "ZSK_TAXIN_T",
    "ZSK_FCURRENCY_T",
];
const SSD_NUMBER_COLUMN = "ZSK_SSDNO";
const REFERENCE_SOURCE_CLEAR_COLUMNS = [
    "ZSK_SANMOTODENNO",
    ...SUPPLY_SOURCE_COLUMNS,
    ...SUPPLY_SOURCE_NAME_COLUMNS,
    SSD_NUMBER_COLUMN,
    ...INVOICE_COLUMNS,
    ...TOTAL_VALUE_COLUMNS,
];
const RAW_PURCHASE_REFERENCE_HEADER_COLUMNS = [
    "ZSK_SANMOTODENNO",
    SSD_NUMBER_COLUMN,
    "ZSK_SIKYUMOTOCD",
    "ZSK_BRDCD",
    "ZSK_SOKOKBN",
    "ZSK_SOKOCD",
    "ZSK_SOKOSUBCD",
    "ZSK_SIKYUMOTOCD_nm",
    "ZSK_BRDCD_nm",
    "ZSK_SOKOKBN_nm",
    "ZSK_SOKOCD_nm",
];
const RAW_PURCHASE_REFERENCE_HEADER_MASTERS = [
    {
        columnId: "ZSK_BRDCD",
        nameColumnId: "ZSK_BRDCD_nm",
        dataId: "M_BRD",
        nameProperty: "BRD_NAMERNM",
    },
    {
        columnId: "ZSK_SOKOKBN",
        nameColumnId: "ZSK_SOKOKBN_nm",
        dataId: "m_code:0010",
        nameProperty: "m_code_name",
    },
];
const RAW_SUPPLY_REFERENCE_HEADER_COLUMNS = [
    "ZSK_SANMOTODENNO",
    "ZSK_SIKYUMOTOCD",
    "ZSK_BRDCD",
    "ZSK_SOKOKBN",
    "ZSK_SOKOCD",
    "ZSK_SOKOSUBCD",
    "ZSK_SIKYUMOTOCD_nm",
    "ZSK_BRDCD_nm",
    "ZSK_SOKOCD_nm",
    ...INVOICE_COLUMNS,
];
const BRAND_PRODUCT_COLUMN = "PDT_SYOHINCD";
const SSD_LINKED_HEADER_COLUMNS = [
    BRAND_PRODUCT_COLUMN,
    "ZSK_SIIRESAKIKBN",
    "ZSK_SIIRESAKICD",
    "ZSK_SIIRESAKISUBCD",
    "ZSK_KAKOUSAKIKBN",
    "ZSK_KAKOUSAKICD",
    "ZSK_KAKOUSAKISUBCD",
    "ZSK_SIKYUKBN",
    "ZSK_KAIGAIKBN",
    "ZSK_TSUKATANI",
    "ZSK_TAXCD",
    "ZSK_SHANAIRATE",
];
const SSD_LINKED_MASTER_NAME_COLUMNS = [
    "ZSK_SIIRESAKICD_nm",
    "ZSK_KAKOUSAKISUBCD_nm",
    "ZSK_SIKYUKBN_nm",
    "ZSK_KAIGAIKBN_nm",
    "ZSK_TSUKATANI_nm",
    "ZSK_TAXCD_nm",
];
const RAW_SUPPLY_REFERENCE_BUSINESS_HEADER_COLUMNS = [
    SSD_NUMBER_COLUMN,
    ...SSD_LINKED_HEADER_COLUMNS,
    "ZSK_CUR",
    ...SSD_LINKED_MASTER_NAME_COLUMNS,
];
const CONDITIONAL_LOCK_COLUMNS = [
    ...SLIP_TYPE_COLUMNS,
    "ZSK_SIKYUBI",
    "ZSK_SANMOTODENKBN",
    "ZSK_SANMOTODENNO",
    ...SUPPLY_SOURCE_COLUMNS,
    "ZSK_SSDNO",
    ...INVOICE_COLUMNS,
];

function normalizeConditionValue(value) {
    return value === null || value === undefined ? "" : String(value).trim();
}

function sumRawSupplyValues(rows, columnId) {
    return rows.reduce((total, row) => {
        const value = NumConv(row?.[columnId]);
        return total + (Number.isFinite(value) ? value : 0);
    }, 0);
}

export function rawSupplyDetailCellEditable(params, baseEditable, entryData, panelType) {
    const normalizedPanelType = normalizeConditionValue(panelType);
    const columnId = normalizeConditionValue(params?.column?.colId).toUpperCase();
    if (!DETAIL_PANEL_TYPES.includes(normalizedPanelType)) return baseEditable;

    const data = entryData || {};
    if (DETAIL_REFERENCE_LOCK_COLUMNS.includes(columnId)
        || (normalizedPanelType === ACCESSORY_DETAIL_PANEL_TYPE
            && ACCESSORY_REFERENCE_LOCK_COLUMNS.includes(columnId))
        || (normalizedPanelType === SUBMATERIAL_DETAIL_PANEL_TYPE
            && SUBMATERIAL_REFERENCE_LOCK_COLUMNS.includes(columnId))) {
        return normalizeConditionValue(data.ZSK_SANMOTODENKBN) === ""
            ? baseEditable
            : false;
    }

    if (columnId === YEN_UNIT_PRICE_COLUMN) {
        if (baseEditable !== true) return false;

        const referenceSource = normalizeConditionValue(data.ZSK_SANMOTODENKBN);
        const isOverseas = normalizeConditionValue(data.ZSK_KAIGAIKBN) === "2";
        const isPaidSupply = normalizeConditionValue(data.ZSK_SIKYUKBN) === "1";
        return !["2", "3"].includes(referenceSource) || (isOverseas && isPaidSupply);
    }

    if (columnId === FOREIGN_CURRENCY_UNIT_PRICE_COLUMN) {
        if (baseEditable !== true) return false;

        const referenceSource = normalizeConditionValue(data.ZSK_SANMOTODENKBN);
        const isOverseas = normalizeConditionValue(data.ZSK_KAIGAIKBN) === "2";
        const isPaidSupply = normalizeConditionValue(data.ZSK_SIKYUKBN) === "1";
        const currencyUnit = normalizeConditionValue(data.ZSK_TSUKATANI).toUpperCase();
        return (referenceSource === "" || referenceSource === "1" || referenceSource === "3")
            && isOverseas
            && isPaidSupply
            && currencyUnit !== ""
            && currencyUnit !== "JPY";
    }

    return baseEditable;
}

export function applyRawSupplyHeaderLocks(fields, baseFields, entryData, formStatus) {
    const data = entryData || {};
    const isInsertForm = formStatus === "NEW FORM" || formStatus === "COPY FORM";
    const hasReferenceSource = normalizeConditionValue(data.ZSK_SANMOTODENKBN) !== "";
    const isOverseas = normalizeConditionValue(data.ZSK_KAIGAIKBN) === "2";
    const isLinkedEntryForm = formStatus === "ENTRY FORM"
        && normalizeConditionValue(data.ZSK_KIKANCP_FLG) === "1";
    let changed = false;

    const nextFields = fields.map(field => {
        if (!CONDITIONAL_LOCK_PANEL_TYPES.includes(field.type)
            || !CONDITIONAL_LOCK_COLUMNS.includes(field.columnid)) return field;

        let conditionalLocked = false;
        if (SLIP_TYPE_COLUMNS.includes(field.columnid)) {
            conditionalLocked = !isInsertForm || hasReferenceSource;
        } else if (field.columnid === "ZSK_SIKYUBI") {
            conditionalLocked = isLinkedEntryForm;
        } else if (field.columnid === "ZSK_SANMOTODENKBN") {
            conditionalLocked = !isInsertForm;
        } else if (field.columnid === "ZSK_SANMOTODENNO") {
            conditionalLocked = !isInsertForm || !hasReferenceSource;
        } else if (SUPPLY_SOURCE_COLUMNS.includes(field.columnid)) {
            conditionalLocked = hasReferenceSource;
        } else if (field.columnid === "ZSK_SSDNO") {
            conditionalLocked = !isInsertForm;
        } else if (INVOICE_COLUMNS.includes(field.columnid)) {
            conditionalLocked = !isOverseas;
        }

        const baseField = baseFields.find(base =>
            base.type === field.type && base.columnid === field.columnid
        );
        const baseLocked = baseField === undefined ? field.locked : baseField.locked;
        const locked = Boolean(baseLocked) || conditionalLocked;
        if (field.locked === locked) return field;

        changed = true;
        return { ...field, locked: locked };
    });

    return changed ? nextFields : fields;
}

export function applyRawSupplyInvoiceInputDefinitions(fields) {
    let changed = false;
    const nextFields = fields.map(field => {
        const length = INVOICE_INPUT_LENGTHS[field.columnid];
        if (length === undefined || field.length === length) return field;

        changed = true;
        return { ...field, length: length };
    });

    return changed ? nextFields : fields;
}

export function applyRawSupplyRateDefinition(fields) {
    let changed = false;
    const nextFields = fields.map(field => {
        if (field.columnid !== "ZSK_SHANAIRATE" || field.decimalplace === 2) return field;

        changed = true;
        return { ...field, decimalplace: 2 };
    });

    return changed ? nextFields : fields;
}

function applyRawSupplyReferenceSourceOptions(fields, materialType) {
    let changed = false;
    const nextFields = fields.map(field => {
        if (field.columnid !== "ZSK_SANMOTODENKBN") return field;

        const options = Array.isArray(field.options) ? field.options : [];
        const hasRawSalesReference = options.some(option =>
            normalizeConditionValue(option?.code) === RAW_SALES_REFERENCE_SOURCE_OPTION.code
        );
        if (["0", "1", "2"].includes(materialType)) {
            if (hasRawSalesReference) return field;
            changed = true;
            return {
                ...field,
                options: [...options, RAW_SALES_REFERENCE_SOURCE_OPTION],
            };
        }
        if (!hasRawSalesReference) return field;

        changed = true;
        return {
            ...field,
            options: options.filter(option =>
                normalizeConditionValue(option?.code) !== RAW_SALES_REFERENCE_SOURCE_OPTION.code
            ),
        };
    });

    return changed ? nextFields : fields;
}

function applyRawSupplyHeaderDefinitions(fields, baseFields, entryData, formStatus, materialType) {
    return applyRawSupplyHeaderLocks(
        applyRawSupplyRateDefinition(
            applyRawSupplyInvoiceInputDefinitions(
                applyRawSupplyReferenceSourceOptions(fields, materialType)
            )
        ),
        baseFields,
        entryData,
        formStatus
    );
}

const RawSupplyInEntry = React.forwardRef(function RawSupplyInEntry(props, ref) {
    const [textFields, setTextFields] = useState([]);
    const dispatch = useDispatch();
    const formStatus = useSelector(state => state.form.status);
    const menuInfo = useSelector(state => state.form.menuinfo);
    const mainLayout = useSelector(state => state.toolpnl.layouts_et);
    const mainPrelayout = useSelector(state => state.toolpnl.prelayout_et);
    const mainInitlayout = useSelector(state => state.toolpnl.initlayout_et);
    const isInsertForm = formStatus === "NEW FORM" || formStatus === "COPY FORM";
    const entryBodyRef = useRef(null);
    const gridRefs = useRef({});
    const lastSuccessfulSsdNoRef = useRef("");
    const ssdHeaderRequestRef = useRef(0);
    const locationValidationRequestRef = useRef(0);
    const materialSelectionRequestRef = useRef(new WeakMap());
    const fzkSelectionRequestRef = useRef(new WeakMap());
    const accessoryCostRequestRef = useRef(new WeakMap());
    const submaterialCostRequestRef = useRef(new WeakMap());
    const copyCostGenerationRef = useRef(0);
    const copyCostStartedRef = useRef(false);
    const copyCostFormStatusRef = useRef(formStatus);
    const tryRefreshCopyCostsRef = useRef(() => {});
    const originalSearchListOpenHandlerRef = useRef(null);
    const wrappedSearchListOpenHandlerRef = useRef(null);
    const rawSupplyLocationDataIdRef = useRef("");
    const [layoutLock, setLayoutLock] = useState(false);
    const [sectionClose, setSectionClose] = useState(false);
    copyCostFormStatusRef.current = formStatus;
    const panels = Array.isArray(props.panels) ? props.panels : [];
    const columnInfo = Array.isArray(props.columninfo) ? props.columninfo : [];
    const columns = Array.isArray(props.columns) ? props.columns : [];
    const materialType = String(props.materialType);
    const activeMaterialType = ["0", "1", "2"].includes(materialType) ? materialType : "0";
    const activePanelTypes = MATERIAL_PANEL_TYPES[activeMaterialType];
    const entryPanelTypes = [...COMMON_ENTRY_PANEL_TYPES, activePanelTypes.detail];
    const materialPanels = panels.filter(panel => entryPanelTypes.includes(panel.type));
    const CELLTYPE = CellType();

    useImperativeHandle(ref, () => ({
        jumpPanel(panel) {
            scrollToPanel(panel);
        },
        getCurrentDetailRows(type) {
            const normalizedType = normalizeConditionValue(type);
            const panel = materialPanels.find(item => item.type === normalizedType);
            if (panel === undefined) return [];

            const key = panel.id + "_" + panel.type + "_" + props.entryDetailResetKey;
            const refs = gridRefs.current[key];
            if (refs === undefined) return [];
            if (refs.api !== null) refs.api.stopEditing();

            const saveColumns = columnInfo.filter(column =>
                column.type === normalizedType
                && normalizeConditionValue(column.table).toUpperCase() === MATERIAL_DETAIL_TABLE
                && normalizeConditionValue(column.columnid).toLowerCase() !== "rowid"
                && !normalizeConditionValue(column.columnid).toLowerCase().endsWith("_nm")
                && !NON_PHYSICAL_DETAIL_COLUMNS.includes(
                    normalizeConditionValue(column.columnid).toUpperCase()
                )
                && column.saveed !== false
                && !column.primary
                && !column.primarykey
                && normalizeConditionValue(column.formula) === ""
                && !column.locked
            );
            const currentRows = Array.isArray(refs.dataRef.current)
                ? refs.dataRef.current
                : [];
            return currentRows
                .filter(row => saveColumns.some(column => {
                    const value = row?.[column.columnid];
                    if (column.datatype === CELLTYPE.NUM) return NumConv(value) !== 0;
                    return normalizeConditionValue(value) !== "";
                }))
                .map(row => ({ ...row }));
        },
    }));

    useEffect(() => {
        const entryColumns = Array.isArray(props.columns) ? props.columns : [];
        const visibleColumns = entryColumns.filter(column =>
            column.logpid === "0" &&
            (COMMON_ENTRY_PANEL_TYPES.includes(column.type) || column.type === activePanelTypes.detail)
        );
        setTextFields(applyRawSupplyHeaderDefinitions(
            visibleColumns,
            entryColumns,
            props.entrydataRef.current,
            formStatus,
            activeMaterialType
        ));
    }, [props.columns, activePanelTypes.detail, formStatus]);

    useEffect(() => {
        const controls = menuInfo?.ctrls || [];
        setLayoutLock(controls.indexOf("LOCK2") !== -1);
        setSectionClose(controls.indexOf("SECCLOSE") !== -1);
    }, [menuInfo]);

    useEffect(() => {
        if (formStatus !== "COPY FORM") {
            if (copyCostStartedRef.current) props.fnc.current.wait(false);
            ++copyCostGenerationRef.current;
            copyCostStartedRef.current = false;
            return;
        }
        tryRefreshCopyCostsRef.current();
    }, [formStatus, activeMaterialType, props.entryDetailResetKey, props.detail]);

    useEffect(() => {
        return () => {
            ++copyCostGenerationRef.current;
            ++locationValidationRequestRef.current;
            const currentFnc = props.fnc.current;
            if (currentFnc !== null
                && currentFnc !== undefined
                && currentFnc.searchlistopen === wrappedSearchListOpenHandlerRef.current) {
                currentFnc.searchlistopen = originalSearchListOpenHandlerRef.current;
            }
            originalSearchListOpenHandlerRef.current = null;
            wrappedSearchListOpenHandlerRef.current = null;
        };
    }, []);

    useEffect(() => {
        const currentFnc = props.fnc.current;
        if (currentFnc === null
            || currentFnc === undefined
            || typeof currentFnc.searchlistopen !== "function"
            || currentFnc.searchlistopen === wrappedSearchListOpenHandlerRef.current) return;

        originalSearchListOpenHandlerRef.current = currentFnc.searchlistopen;
        wrappedSearchListOpenHandlerRef.current = function (param) {
            const searchData = param?.data;
            const isLocationSearch = normalizeConditionValue(searchData?.table).toUpperCase() === "D_ZSK"
                && normalizeConditionValue(searchData?.columnid).toUpperCase() === "ZSK_SOKOCD";
            const isProcessingOrderSearch = normalizeConditionValue(searchData?.table).toUpperCase() === "D_ZSK"
                && normalizeConditionValue(searchData?.columnid).toUpperCase() === SSD_NUMBER_COLUMN;
            if ((!isLocationSearch && !isProcessingOrderSearch)
                || typeof param?.doApply !== "function") {
                originalSearchListOpenHandlerRef.current.call(currentFnc, param);
                return;
            }

            const originalDoApply = param.doApply;
            const originalDataId = normalizeConditionValue(searchData?.dataid);
            const entryData = props.entrydataRef.current || {};
            if (isProcessingOrderSearch) {
                currentFnc.postaxios(
                    'RawSupplyIn/GetProcessingOrderOptions',
                    {
                        data: {
                            brandCode: normalizeConditionValue(entryData.ZSK_BRDCD),
                        },
                    },
                    {
                        onSuccess: function (data) {
                            const options = Array.isArray(data?.rowdata)
                                ? data.rowdata
                                    .map(row => ({
                                        rowid: normalizeConditionValue(row?.rowid),
                                        code: normalizeConditionValue(row?.code),
                                        name: normalizeConditionValue(row?.name),
                                    }))
                                    .filter(option => option.code !== "")
                                : [];

                            currentFnc.wait(false);
                            if (options.length === 0) {
                                dispatch(warnmsg("加工指示番号の検索候補がありません。"));
                                return;
                            }

                            originalSearchListOpenHandlerRef.current.call(currentFnc, {
                                ...param,
                                data: {
                                    ...searchData,
                                    dataid: "",
                                    datatype: CELLTYPE.SELECT,
                                    options,
                                },
                                doApply: originalDoApply,
                            });
                        },
                    }
                );
                return;
            }

            rawSupplyLocationDataIdRef.current = originalDataId;
            currentFnc.postaxios(
                'RawSupplyIn/GetLocationOptions',
                {
                    data: {
                        sokoKbn: normalizeConditionValue(entryData.ZSK_SOKOKBN),
                        supplySourceCode: normalizeConditionValue(entryData.ZSK_SIKYUMOTOCD),
                        brandCode: normalizeConditionValue(entryData.ZSK_BRDCD),
                        supplyDate: normalizeConditionValue(entryData.ZSK_SIKYUBI),
                        accountingDate: normalizeConditionValue(entryData.ZSK_KEIJYODATE),
                    },
                },
                {
                    onSuccess: function (data) {
                        const options = Array.isArray(data?.rowdata)
                            ? data.rowdata
                                .map(row => ({
                                    rowid: normalizeConditionValue(row?.rowid),
                                    code: normalizeConditionValue(row?.code),
                                    name: normalizeConditionValue(row?.name),
                                    TOR_CODE: normalizeConditionValue(row?.TOR_CODE),
                                    TOR_SUBCODE: normalizeConditionValue(row?.TOR_SUBCODE),
                                }))
                                .filter(option => option.code !== ""
                                    && option.TOR_CODE !== ""
                                    && option.TOR_SUBCODE !== "")
                            : [];

                        currentFnc.wait(false);
                        if (options.length === 0) {
                            dispatch(warnmsg("在庫場所の検索候補がありません。"));
                            return;
                        }

                        originalSearchListOpenHandlerRef.current.call(currentFnc, {
                            ...param,
                            data: {
                                ...searchData,
                                dataid: "",
                                datatype: CELLTYPE.SELECT,
                                options,
                            },
                            doApply: result => applyRawSupplyLocationSearchResult(
                                result,
                                originalDoApply,
                                originalDataId
                            ),
                        });
                    },
                }
            );
        };
        currentFnc.searchlistopen = wrappedSearchListOpenHandlerRef.current;
    });

    function refreshRawSupplyHeader() {
        props.fnc.current.entryrerender();
        setTextFields(current => applyRawSupplyHeaderDefinitions(
            current,
            Array.isArray(props.columns) ? props.columns : [],
            props.entrydataRef.current,
            formStatus,
            activeMaterialType
        ));
    }

    function updateEntryData(update) {
        const nextData = { ...(props.entrydataRef.current || {}) };
        update(nextData);
        props.entrydataRef.current = nextData;
    }

    function applyRawSupplyLocationSearchResult(result, originalDoApply, originalDataId) {
        const selectedRow = result?.items?.[0]?.data;
        const sokoKbn = normalizeConditionValue(props.entrydataRef.current?.ZSK_SOKOKBN);
        const displayCode = sokoKbn === "2"
            ? normalizeConditionValue(selectedRow?.code)
            : normalizeConditionValue(selectedRow?.TOR_CODE);
        const locationCode = normalizeConditionValue(selectedRow?.TOR_CODE);
        const locationSubCode = normalizeConditionValue(selectedRow?.TOR_SUBCODE);
        const locationName = normalizeConditionValue(selectedRow?.name);
        if (displayCode === "" || locationCode === "" || locationSubCode === "") {
            dispatch(warnmsg("在庫場所のコードを取得できません。"));
            return;
        }

        updateEntryData(nextData => {
            nextData.ZSK_SOKOSUBCD = locationSubCode;
        });
        if (originalDataId !== "" && typeof props.fnc.current.setMaster === "function") {
            props.fnc.current.setMaster({
                dataid: originalDataId,
                code: displayCode,
                keyinfo: "",
                NAME: locationName,
                NAMERNM: locationName,
                TOR_NAME: locationName,
                TOR_NAMERNM: locationName,
                TOR_SUBCDNAMERNM: locationName,
                TOR_CODE: locationCode,
                TOR_SUBCODE: locationSubCode,
            });
        }
        originalDoApply({
            ...result,
            value: displayCode,
        });
    }

    function validateRawSupplyLocation(sokoKbn) {
        const requestNo = ++locationValidationRequestRef.current;
        const entryData = props.entrydataRef.current || {};
        const locationCode = normalizeConditionValue(entryData.ZSK_SOKOCD);
        if (locationCode === "") return;

        const request = {
            sokoKbn: normalizeConditionValue(sokoKbn),
            displayCode: locationCode,
            supplySourceCode: normalizeConditionValue(entryData.ZSK_SIKYUMOTOCD),
            brandCode: normalizeConditionValue(entryData.ZSK_BRDCD),
            supplyDate: normalizeConditionValue(entryData.ZSK_SIKYUBI),
            accountingDate: normalizeConditionValue(entryData.ZSK_KEIJYODATE),
        };
        props.fnc.current.postaxios(
            'RawSupplyIn/ValidateLocation',
            { data: request },
            {
                onSuccess: function (data) {
                    const currentData = props.entrydataRef.current || {};
                    if (requestNo !== locationValidationRequestRef.current
                        || normalizeConditionValue(currentData.ZSK_SOKOKBN) !== request.sokoKbn
                        || normalizeConditionValue(currentData.ZSK_SOKOCD) !== request.displayCode) return;
                    if (data?.data?.valid === true) {
                        const resolvedName = normalizeConditionValue(data?.data?.name);
                        const locationDataId = rawSupplyLocationDataIdRef.current;
                        if (locationDataId !== ""
                            && resolvedName !== ""
                            && typeof props.fnc.current.setMaster === "function") {
                            props.fnc.current.setMaster({
                                dataid: locationDataId,
                                code: request.displayCode,
                                keyinfo: "",
                                NAME: resolvedName,
                                NAMERNM: resolvedName,
                                TOR_NAME: resolvedName,
                                TOR_NAMERNM: resolvedName,
                                TOR_SUBCDNAMERNM: resolvedName,
                                TOR_CODE: normalizeConditionValue(data?.data?.TOR_CODE),
                                TOR_SUBCODE: normalizeConditionValue(data?.data?.TOR_SUBCODE),
                            });
                        }
                        return;
                    }

                    const locationDataId = rawSupplyLocationDataIdRef.current;
                    if (locationDataId !== ""
                        && typeof props.fnc.current.removeMaster === "function") {
                        props.fnc.current.removeMaster(locationDataId, request.displayCode);
                    }
                    updateEntryData(nextData => {
                        nextData.ZSK_SOKOCD = "";
                        nextData.ZSK_SOKOSUBCD = "";
                        nextData.ZSK_SOKOCD_nm = "";
                        nextData.ZSK_SOKOSUBCD_nm = "";
                        nextData.ZSK_SOKO_NM = "";
                    });
                    refreshRawSupplyHeader();
                },
            },
            true
        );
    }

    function clearSsdLinkedHeaderValues(nextData) {
        SSD_LINKED_HEADER_COLUMNS.forEach(columnId => {
            nextData[columnId] = "";
        });
        SSD_LINKED_MASTER_NAME_COLUMNS.forEach(columnId => {
            nextData[columnId] = "";
        });
    }

    function clearInvoiceValues(nextData) {
        INVOICE_COLUMNS.forEach(columnId => {
            nextData[columnId] = "";
        });
    }

    function initializeInvoiceValues(nextData, rowdata) {
        clearInvoiceValues(nextData);
        if (normalizeConditionValue(rowdata.ZSK_KAIGAIKBN) === "2") {
            nextData.ZSK_INVOICEEDA = "0000";
        }
    }

    function restoreSsdHeaderAfterError() {
        updateEntryData(nextData => {
            if (lastSuccessfulSsdNoRef.current === "") {
                nextData[SSD_NUMBER_COLUMN] = "";
                clearSsdLinkedHeaderValues(nextData);
                clearInvoiceValues(nextData);
            } else {
                nextData[SSD_NUMBER_COLUMN] = lastSuccessfulSsdNoRef.current;
            }
        });
        refreshRawSupplyHeader();
    }

    function applySsdHeaderValues(
        rowdata,
        initializeInvoice,
        purchaseReference,
        purchaseOverseasFree,
        purchaseDomesticPaid,
        purchaseOverseasPaid
    ) {
        updateEntryData(nextData => {
            SSD_LINKED_MASTER_NAME_COLUMNS.forEach(columnId => {
                nextData[columnId] = rowdata[columnId] ?? "";
            });
            SSD_LINKED_HEADER_COLUMNS.forEach(columnId => {
                nextData[columnId] = rowdata[columnId] ?? "";
            });
            if (initializeInvoice) {
                initializeInvoiceValues(nextData, rowdata);
            }
            if (purchaseOverseasFree) {
                nextData.ZSK_TSUKATANI = "JPY";
                nextData.ZSK_CUR = "2";
                nextData.ZSK_SHANAIRATE = "1.00";
            } else if (purchaseDomesticPaid || purchaseOverseasPaid) {
                nextData.ZSK_CUR = "2";
            } else if (purchaseReference
                && normalizeConditionValue(nextData.ZSK_CUR) === "2") {
                nextData.ZSK_CUR = "";
            }
        });
    }

    function getSsdHeaderInfo(ssdNo, brandCode, supplyDate, options = {}) {
        const requestNo = ++ssdHeaderRequestRef.current;
        props.fnc.current.postaxios(
            'RawSupplyIn/GetSsdHeaderInfo',
            {
                data: {
                    ssdNo: ssdNo,
                    brandCode: brandCode,
                    supplyDate: supplyDate,
                },
            },
            {
                onSuccess: function (data) {
                    const currentSsdNo = normalizeConditionValue(
                        props.entrydataRef.current?.[SSD_NUMBER_COLUMN]
                    );
                    if (requestNo !== ssdHeaderRequestRef.current
                        || currentSsdNo !== ssdNo) return;
                    if (data.rowdata === null || data.rowdata === undefined) {
                        restoreSsdHeaderAfterError();
                        dispatch(warnmsg("加工指示情報を取得できません。"));
                        return;
                    }

                    const materialPurchaseReference =
                        options.materialPurchaseReference === true;
                    const accessoryPurchaseReference =
                        options.accessoryPurchaseReference === true;
                    const submaterialPurchaseReference =
                        options.submaterialPurchaseReference === true;
                    const purchaseReference = materialPurchaseReference
                        || accessoryPurchaseReference
                        || submaterialPurchaseReference;
                    const purchaseOverseasFree =
                        purchaseReference
                        && normalizeConditionValue(data.rowdata.ZSK_KAIGAIKBN) === "2"
                        && normalizeConditionValue(data.rowdata.ZSK_SIKYUKBN) === "2";
                    const purchaseDomesticPaid =
                        purchaseReference
                        && normalizeConditionValue(data.rowdata.ZSK_KAIGAIKBN) === "1"
                        && normalizeConditionValue(data.rowdata.ZSK_SIKYUKBN) === "1";
                    const purchaseOverseasPaid =
                        purchaseReference
                        && normalizeConditionValue(data.rowdata.ZSK_KAIGAIKBN) === "2"
                        && normalizeConditionValue(data.rowdata.ZSK_SIKYUKBN) === "1";
                    applySsdHeaderValues(
                        data.rowdata,
                        lastSuccessfulSsdNoRef.current !== ssdNo,
                        purchaseReference,
                        purchaseOverseasFree,
                        purchaseDomesticPaid,
                        purchaseOverseasPaid
                    );
                    lastSuccessfulSsdNoRef.current = ssdNo;
                    refreshRawSupplyHeader();
                    refreshAccessoryRawPurchaseReferenceDetail();
                    refreshSubmaterialRawPurchaseReferenceDetail();
                    if (typeof options.onSuccess === "function") {
                        options.onSuccess({
                            ...data.rowdata,
                            ...(purchaseOverseasFree
                                ? {
                                    ZSK_TSUKATANI: "JPY",
                                    ZSK_CUR: "2",
                                    ZSK_SHANAIRATE: "1.00",
                                }
                                : purchaseOverseasPaid
                                    ? { ZSK_CUR: "2" }
                                    : {}),
                        });
                    }
                },
                onError: function (data) {
                    const currentSsdNo = normalizeConditionValue(
                        props.entrydataRef.current?.[SSD_NUMBER_COLUMN]
                    );
                    if (requestNo !== ssdHeaderRequestRef.current
                        || currentSsdNo !== ssdNo) return;

                    restoreSsdHeaderAfterError();
                    dispatch(warnmsg(
                        normalizeConditionValue(data?.errDescription)
                        || "加工指示情報を取得できません。"
                    ));
                },
            },
            true
        );
    }

    function clearRawPurchaseReferenceValues(referenceNo) {
        ++ssdHeaderRequestRef.current;
        lastSuccessfulSsdNoRef.current = "";
        updateEntryData(nextData => {
            REFERENCE_SOURCE_CLEAR_COLUMNS.forEach(columnId => {
                nextData[columnId] = "";
            });
            clearSsdLinkedHeaderValues(nextData);
            nextData.ZSK_SANMOTODENNO = referenceNo;
        });
        refreshRawSupplyHeader();
        props.resetReferenceSourceDetail();
    }

    function applyRawPurchaseReferenceHeader(rowdata, materialType) {
        updateEntryData(nextData => {
            RAW_PURCHASE_REFERENCE_HEADER_COLUMNS.forEach(columnId => {
                nextData[columnId] = rowdata[columnId] ?? "";
            });
            if (materialType !== "0") {
                nextData.ZSK_KAIGAIKBN = "1";
                nextData.ZSK_SIKYUKBN = "2";
            }
        });
    }

    function cacheRawPurchaseReferenceHeaderMasters(rowdata) {
        const entryData = props.entrydataRef.current || {};
        RAW_PURCHASE_REFERENCE_HEADER_MASTERS.forEach(master => {
            const code = normalizeConditionValue(rowdata[master.columnId]);
            const name = normalizeConditionValue(rowdata[master.nameColumnId]);
            if (code === ""
                || name === ""
                || normalizeConditionValue(entryData[master.columnId]) !== code) return;

            props.fnc.current.setMaster({
                dataid: master.dataId,
                code: code,
                [master.nameProperty]: name,
            });
        });
    }

    function handleRawPurchaseReferenceError(message) {
        updateEntryData(nextData => {
            REFERENCE_SOURCE_CLEAR_COLUMNS.forEach(columnId => {
                nextData[columnId] = "";
            });
            clearSsdLinkedHeaderValues(nextData);
        });
        refreshRawSupplyHeader();
        props.resetReferenceSourceDetail();
        dispatch(warnmsg(
            normalizeConditionValue(message)
            || "原材料仕入参照データを取得できません。"
        ));
    }

    function applyMaterialRawPurchaseReferenceDetail(detail, entryData) {
        const currentDetail = detail === null || detail === undefined ? {} : detail;
        const isOverseas = normalizeConditionValue(entryData.ZSK_KAIGAIKBN) === "2";
        const isPaidSupply = normalizeConditionValue(entryData.ZSK_SIKYUKBN) === "1";

        const materialRows = Array.isArray(currentDetail[MATERIAL_DETAIL_PANEL_TYPE])
            ? currentDetail[MATERIAL_DETAIL_PANEL_TYPE]
            : [];
        const currencyUnit = normalizeConditionValue(entryData.ZSK_TSUKATANI).toUpperCase();
        const exchangeRateValue = normalizeConditionValue(entryData.ZSK_SHANAIRATE);
        const exchangeRate = Number(exchangeRateValue);
        let rateUnavailable = false;
        let amountUnavailable = false;
        const rows = materialRows.map(sourceRow => {
            const row = { ...sourceRow };
            if (isOverseas && isPaidSupply && currencyUnit !== "" && currencyUnit !== "JPY") {
                if (exchangeRateValue === ""
                    || !Number.isFinite(exchangeRate)
                    || exchangeRate <= 0) {
                    row.ZSKM_TANKA = "";
                    row.ZSKM_TANKAF = "";
                    rateUnavailable = true;
                } else {
                    const foreignUnitPrice = GetDesitRound(
                        NumConv(row.INITIAL_FOREIGN_UNIT_PRICE)
                            * (1 + NumConv(row.SUPPLY_UPLIFT_RATE)),
                        1,
                        2
                    );
                    row.ZSKM_TANKAF = foreignUnitPrice;
                    row.ZSKM_TANKA = GetDesitRound(
                        foreignUnitPrice * exchangeRate,
                        1,
                        2
                    );
                }
            } else if (isOverseas) {
                row.ZSKM_TANKA = isPaidSupply
                    ? NumConv(row.ZSKM_HEIKINTANKA)
                    : GetDesitRound(
                        NumConv(row.ZSKM_HEIKINTANKA)
                            * (1 + NumConv(row.SUPPLY_UPLIFT_RATE)),
                        1,
                        2
                    );
                row.ZSKM_TANKAF = 0;
            }
            amountUnavailable = !calculateDetailAmounts(
                row,
                TOTAL_DETAIL_SUMMARY_TYPES["111"].quantityColumn,
                entryData
            ) || amountUnavailable;
            return row;
        });
        if (rateUnavailable) {
            dispatch(warnmsg("支給単価の換算に必要なレートを取得できません。"));
        }
        if (amountUnavailable) {
            dispatch(warnmsg("原材料金額の端数設定を取得できません。"));
        }
        return {
            ...currentDetail,
            [MATERIAL_DETAIL_PANEL_TYPE]: rows,
        };
    }

    function applyAccessoryRawPurchaseReferenceRow(row, entryData) {
        const isOverseas = normalizeConditionValue(entryData.ZSK_KAIGAIKBN) === "2";
        const isPaidSupply = normalizeConditionValue(entryData.ZSK_SIKYUKBN) === "1";
        const isOverseasPaid = isOverseas && isPaidSupply;
        const currencyUnit = normalizeConditionValue(entryData.ZSK_TSUKATANI).toUpperCase();
        const exchangeRateValue = normalizeConditionValue(entryData.ZSK_SHANAIRATE);
        const exchangeRate = Number(exchangeRateValue);
        let rateUnavailable = false;

        const cost = NumConv(row.ZSKM_HEIKINTANKA);
        if (isOverseasPaid && currencyUnit !== "" && currencyUnit !== "JPY") {
            if (exchangeRateValue === ""
                || !Number.isFinite(exchangeRate)
                || exchangeRate <= 0) {
                row.ZSKM_TANKA = "";
                row.ZSKM_TANKAF = "";
                rateUnavailable = true;
            } else {
                const foreignUnitPrice = GetDesitRound(
                    NumConv(row.INITIAL_FOREIGN_UNIT_PRICE)
                        * (1 + NumConv(row.SUPPLY_UPLIFT_RATE)),
                    1,
                    2
                );
                row.ZSKM_TANKAF = foreignUnitPrice;
                row.ZSKM_TANKA = GetDesitRound(
                    foreignUnitPrice * exchangeRate,
                    1,
                    2
                );
            }
        } else {
            row.ZSKM_TANKA = isOverseas && !isPaidSupply
                ? GetDesitRound(
                    cost * (1 + NumConv(row.SUPPLY_UPLIFT_RATE)),
                    1,
                    2
                )
                : cost;
            row.ZSKM_TANKAF = 0;
        }

        return {
            rateUnavailable: rateUnavailable,
            amountUnavailable: !calculateDetailAmounts(
                row,
                TOTAL_DETAIL_SUMMARY_TYPES["121"].quantityColumn,
                entryData
            ),
        };
    }

    function warnAccessoryRawPurchaseReferenceCalculation(result) {
        if (result.rateUnavailable) {
            dispatch(warnmsg("支給単価の換算に必要なレートを取得できません。"));
        }
        if (result.amountUnavailable) {
            dispatch(warnmsg("原材料金額の端数設定を取得できません。"));
        }
    }

    function applyAccessoryRawPurchaseReferenceDetail(detail) {
        const currentDetail = detail === null || detail === undefined ? {} : detail;
        const accessoryRows = Array.isArray(currentDetail[ACCESSORY_DETAIL_PANEL_TYPE])
            ? currentDetail[ACCESSORY_DETAIL_PANEL_TYPE]
            : [];
        const entryData = props.entrydataRef.current || {};
        const result = { rateUnavailable: false, amountUnavailable: false };
        const rows = accessoryRows.map(sourceRow => {
            const row = { ...sourceRow };
            const rowResult = applyAccessoryRawPurchaseReferenceRow(row, entryData);
            result.rateUnavailable = result.rateUnavailable || rowResult.rateUnavailable;
            result.amountUnavailable = result.amountUnavailable || rowResult.amountUnavailable;
            return row;
        });

        warnAccessoryRawPurchaseReferenceCalculation(result);
        return {
            ...currentDetail,
            [ACCESSORY_DETAIL_PANEL_TYPE]: rows,
        };
    }

    function refreshAccessoryRawPurchaseReferenceDetail() {
        if (activeMaterialType !== "1"
            || normalizeConditionValue(props.entrydataRef.current?.ZSK_SANMOTODENKBN)
                !== "1") return;

        const entryData = props.entrydataRef.current || {};
        const result = { rateUnavailable: false, amountUnavailable: false };
        materialPanels
            .filter(panel => panel.type === ACCESSORY_DETAIL_PANEL_TYPE)
            .forEach(panel => {
                const key = panel.id + "_" + panel.type + "_" + props.entryDetailResetKey;
                const targetRefs = gridRefs.current[key];
                if (targetRefs === undefined || !Array.isArray(targetRefs.dataRef.current)) return;

                targetRefs.dataRef.current = targetRefs.dataRef.current.map(sourceRow => {
                    const row = { ...sourceRow };
                    const rowResult = applyAccessoryRawPurchaseReferenceRow(row, entryData);
                    result.rateUnavailable = result.rateUnavailable || rowResult.rateUnavailable;
                    result.amountUnavailable = result.amountUnavailable || rowResult.amountUnavailable;
                    return row;
                });
                props.fnc.current.rerenderGrid(props.fnc.current.GridID(panel.id));
                refreshAccessoryTotalRows(targetRefs);
            });
        warnAccessoryRawPurchaseReferenceCalculation(result);
    }

    function applySubmaterialRawPurchaseReferenceRow(row, entryData) {
        const isOverseas = normalizeConditionValue(entryData.ZSK_KAIGAIKBN) === "2";
        const isPaidSupply = normalizeConditionValue(entryData.ZSK_SIKYUKBN) === "1";
        const isOverseasPaid = isOverseas && isPaidSupply;
        const currencyUnit = normalizeConditionValue(entryData.ZSK_TSUKATANI).toUpperCase();
        const exchangeRateValue = normalizeConditionValue(entryData.ZSK_SHANAIRATE);
        const exchangeRate = Number(exchangeRateValue);
        let rateUnavailable = false;

        const cost = NumConv(row.ZSKM_HEIKINTANKA);
        if (isOverseasPaid && currencyUnit !== "" && currencyUnit !== "JPY") {
            if (exchangeRateValue === ""
                || !Number.isFinite(exchangeRate)
                || exchangeRate <= 0) {
                row.ZSKM_TANKA = "";
                row.ZSKM_TANKAF = "";
                rateUnavailable = true;
            } else {
                const foreignUnitPrice = GetDesitRound(
                    NumConv(row.INITIAL_FOREIGN_UNIT_PRICE)
                        * (1 + NumConv(row.SUPPLY_UPLIFT_RATE)),
                    1,
                    2
                );
                row.ZSKM_TANKAF = foreignUnitPrice;
                row.ZSKM_TANKA = GetDesitRound(
                    foreignUnitPrice * exchangeRate,
                    1,
                    2
                );
            }
        } else {
            row.ZSKM_TANKA = isOverseas && !isPaidSupply
                ? GetDesitRound(
                    cost * (1 + NumConv(row.SUPPLY_UPLIFT_RATE)),
                    1,
                    2
                )
                : cost;
            row.ZSKM_TANKAF = 0;
        }

        return {
            rateUnavailable: rateUnavailable,
            amountUnavailable: !calculateDetailAmounts(
                row,
                TOTAL_DETAIL_SUMMARY_TYPES["131"].quantityColumn,
                entryData
            ),
        };
    }

    function warnSubmaterialRawPurchaseReferenceCalculation(result) {
        if (result.rateUnavailable) {
            dispatch(warnmsg("支給単価の換算に必要なレートを取得できません。"));
        }
        if (result.amountUnavailable) {
            dispatch(warnmsg("原材料金額の端数設定を取得できません。"));
        }
    }

    function applySubmaterialRawPurchaseReferenceDetail(detail) {
        const currentDetail = detail === null || detail === undefined ? {} : detail;
        const submaterialRows = Array.isArray(currentDetail[SUBMATERIAL_DETAIL_PANEL_TYPE])
            ? currentDetail[SUBMATERIAL_DETAIL_PANEL_TYPE]
            : [];
        const entryData = props.entrydataRef.current || {};
        const result = { rateUnavailable: false, amountUnavailable: false };
        const rows = submaterialRows.map(sourceRow => {
            const row = { ...sourceRow };
            const rowResult = applySubmaterialRawPurchaseReferenceRow(row, entryData);
            result.rateUnavailable = result.rateUnavailable || rowResult.rateUnavailable;
            result.amountUnavailable = result.amountUnavailable || rowResult.amountUnavailable;
            return row;
        });

        warnSubmaterialRawPurchaseReferenceCalculation(result);
        return {
            ...currentDetail,
            [SUBMATERIAL_DETAIL_PANEL_TYPE]: rows,
        };
    }

    function refreshSubmaterialRawPurchaseReferenceDetail() {
        if (activeMaterialType !== "2"
            || normalizeConditionValue(props.entrydataRef.current?.ZSK_SANMOTODENKBN)
                !== "1") return;

        const entryData = props.entrydataRef.current || {};
        const result = { rateUnavailable: false, amountUnavailable: false };
        materialPanels
            .filter(panel => panel.type === SUBMATERIAL_DETAIL_PANEL_TYPE)
            .forEach(panel => {
                const key = panel.id + "_" + panel.type + "_" + props.entryDetailResetKey;
                const targetRefs = gridRefs.current[key];
                if (targetRefs === undefined || !Array.isArray(targetRefs.dataRef.current)) return;

                targetRefs.dataRef.current = targetRefs.dataRef.current.map(sourceRow => {
                    const row = { ...sourceRow };
                    const rowResult = applySubmaterialRawPurchaseReferenceRow(row, entryData);
                    result.rateUnavailable = result.rateUnavailable || rowResult.rateUnavailable;
                    result.amountUnavailable = result.amountUnavailable || rowResult.amountUnavailable;
                    return row;
                });
                props.fnc.current.rerenderGrid(props.fnc.current.GridID(panel.id));
                refreshSubmaterialTotalRows(targetRefs);
            });
        warnSubmaterialRawPurchaseReferenceCalculation(result);
    }

    function getRawPurchaseReferenceInfo(referenceNo, requestMaterialType) {
        const requestNo = ++props.rawPurchaseReferenceRequestRef.current;
        props.fnc.current.postaxios(
            'RawSupplyIn/GetRawPurchaseReferenceInfo',
            {
                data: {
                    referenceNo: referenceNo,
                    materialType: requestMaterialType,
                },
            },
            {
                onSuccess: function (data) {
                    const entryData = props.entrydataRef.current || {};
                    if (requestNo !== props.rawPurchaseReferenceRequestRef.current
                        || normalizeConditionValue(entryData.ZSK_SANMOTODENKBN) !== "1"
                        || normalizeConditionValue(entryData.ZSK_SANMOTODENNO) !== referenceNo
                        || props.rawPurchaseReferenceMaterialTypeRef.current
                            !== requestMaterialType) return;
                    if (data.data === null || data.data === undefined) {
                        handleRawPurchaseReferenceError(data.errDescription);
                        return;
                    }

                    applyRawPurchaseReferenceHeader(data.data, requestMaterialType);
                    cacheRawPurchaseReferenceHeaderMasters(data.data);
                    refreshRawSupplyHeader();
                    if (["0", "1", "2"].includes(requestMaterialType)) {
                        const sourceSsdNo = normalizeConditionValue(
                            data.data[SSD_NUMBER_COLUMN]
                        );
                        if (/^[0-9]{8}$/.test(sourceSsdNo)) {
                            getSsdHeaderInfo(
                                sourceSsdNo,
                                normalizeConditionValue(data.data.ZSK_BRDCD),
                                normalizeConditionValue(entryData.ZSK_SIKYUBI),
                                {
                                    materialPurchaseReference: requestMaterialType === "0",
                                    accessoryPurchaseReference: requestMaterialType === "1",
                                    submaterialPurchaseReference: requestMaterialType === "2",
                                    onSuccess: function (ssdHeader) {
                                        props.applyRawPurchaseReferenceDetail(
                                            requestMaterialType === "0"
                                                ? applyMaterialRawPurchaseReferenceDetail(
                                                    data.detail,
                                                    {
                                                        ...(props.entrydataRef.current || {}),
                                                        ...ssdHeader,
                                                    }
                                                )
                                                : requestMaterialType === "1"
                                                    ? applyAccessoryRawPurchaseReferenceDetail(
                                                        data.detail
                                                    )
                                                    : applySubmaterialRawPurchaseReferenceDetail(
                                                        data.detail
                                                    )
                                        );
                                    },
                                }
                            );
                            return;
                        }
                    }
                    const appliedDetail = requestMaterialType === "1"
                        ? applyAccessoryRawPurchaseReferenceDetail(data.detail)
                        : requestMaterialType === "2"
                            ? applySubmaterialRawPurchaseReferenceDetail(data.detail)
                            : data.detail;
                    props.applyRawPurchaseReferenceDetail(
                        appliedDetail
                    );
                },
                onError: function (data) {
                    const entryData = props.entrydataRef.current || {};
                    if (requestNo !== props.rawPurchaseReferenceRequestRef.current
                        || normalizeConditionValue(entryData.ZSK_SANMOTODENKBN) !== "1"
                        || normalizeConditionValue(entryData.ZSK_SANMOTODENNO) !== referenceNo
                        || props.rawPurchaseReferenceMaterialTypeRef.current
                            !== requestMaterialType) return;
                    handleRawPurchaseReferenceError(data?.errDescription);
                },
            },
            true
        );
    }

    function clearRawSupplyReferenceValues(referenceNo) {
        ++ssdHeaderRequestRef.current;
        lastSuccessfulSsdNoRef.current = "";
        updateEntryData(nextData => {
            REFERENCE_SOURCE_CLEAR_COLUMNS.forEach(columnId => {
                nextData[columnId] = "";
            });
            clearSsdLinkedHeaderValues(nextData);
            nextData.ZSK_SANMOTODENNO = referenceNo;
        });
        refreshRawSupplyHeader();
        props.resetReferenceSourceDetail();
    }

    function applyRawSupplyReferenceHeader(rowdata) {
        updateEntryData(nextData => {
            [
                ...RAW_SUPPLY_REFERENCE_HEADER_COLUMNS,
                ...RAW_SUPPLY_REFERENCE_BUSINESS_HEADER_COLUMNS,
            ].forEach(columnId => {
                nextData[columnId] = rowdata[columnId] ?? "";
            });
        });
    }

    function handleRawSupplyReferenceError(message) {
        updateEntryData(nextData => {
            REFERENCE_SOURCE_CLEAR_COLUMNS.forEach(columnId => {
                nextData[columnId] = "";
            });
            clearSsdLinkedHeaderValues(nextData);
        });
        refreshRawSupplyHeader();
        props.resetReferenceSourceDetail();
        dispatch(warnmsg(
            normalizeConditionValue(message)
            || "対象の原材料支給伝票を取得できません。"
        ));
    }

    function getRawSupplyReferenceInfo(referenceNo, requestMaterialType) {
        const requestNo = ++props.rawSupplyReferenceRequestRef.current;
        props.fnc.current.postaxios(
            'RawSupplyIn/GetRawSupplyReferenceInfo',
            {
                data: {
                    referenceNo: referenceNo,
                    materialType: requestMaterialType,
                },
            },
            {
                onSuccess: function (data) {
                    const entryData = props.entrydataRef.current || {};
                    if (requestNo !== props.rawSupplyReferenceRequestRef.current
                        || normalizeConditionValue(entryData.ZSK_SANMOTODENKBN) !== "2"
                        || normalizeConditionValue(entryData.ZSK_SANMOTODENNO) !== referenceNo
                        || props.rawPurchaseReferenceMaterialTypeRef.current !== requestMaterialType) return;
                    if (data.data === null || data.data === undefined) {
                        handleRawSupplyReferenceError(data.errDescription);
                        return;
                    }

                    applyRawSupplyReferenceHeader(data.data);
                    lastSuccessfulSsdNoRef.current = normalizeConditionValue(
                        data.data[SSD_NUMBER_COLUMN]
                    );
                    refreshRawSupplyHeader();
                    props.applyRawSupplyReferenceDetail(data.detail);
                },
                onError: function (data) {
                    const entryData = props.entrydataRef.current || {};
                    if (requestNo !== props.rawSupplyReferenceRequestRef.current
                        || normalizeConditionValue(entryData.ZSK_SANMOTODENKBN) !== "2"
                        || normalizeConditionValue(entryData.ZSK_SANMOTODENNO) !== referenceNo
                        || props.rawPurchaseReferenceMaterialTypeRef.current !== requestMaterialType) return;
                    handleRawSupplyReferenceError(data?.errDescription);
                },
            },
            true
        );
    }

    function handleRawSalesReferenceError(message) {
        clearRawSupplyReferenceValues("");
        dispatch(warnmsg(
            normalizeConditionValue(message)
            || "対象の原材料売上伝票を取得できません。"
        ));
    }

    function getRawSalesReferenceInfo(referenceNo, requestMaterialType) {
        const requestNo = ++props.rawSupplyReferenceRequestRef.current;
        props.fnc.current.postaxios(
            'RawSupplyIn/GetRawSalesReferenceInfo',
            {
                data: {
                    referenceNo: referenceNo,
                    materialType: requestMaterialType,
                },
            },
            {
                onSuccess: function (data) {
                    const entryData = props.entrydataRef.current || {};
                    if (requestNo !== props.rawSupplyReferenceRequestRef.current
                        || normalizeConditionValue(entryData.ZSK_SANMOTODENKBN) !== "3"
                        || normalizeConditionValue(entryData.ZSK_SANMOTODENNO) !== referenceNo
                        || props.rawPurchaseReferenceMaterialTypeRef.current
                            !== requestMaterialType) return;
                    if (data.data === null || data.data === undefined) {
                        handleRawSalesReferenceError(data.errDescription);
                        return;
                    }

                    applyRawSupplyReferenceHeader(data.data);
                    lastSuccessfulSsdNoRef.current = normalizeConditionValue(
                        data.data[SSD_NUMBER_COLUMN]
                    );
                    refreshRawSupplyHeader();
                    props.applyRawSupplyReferenceDetail(data.detail);
                },
                onError: function (data) {
                    const entryData = props.entrydataRef.current || {};
                    if (requestNo !== props.rawSupplyReferenceRequestRef.current
                        || normalizeConditionValue(entryData.ZSK_SANMOTODENKBN) !== "3"
                        || normalizeConditionValue(entryData.ZSK_SANMOTODENNO) !== referenceNo
                        || props.rawPurchaseReferenceMaterialTypeRef.current
                            !== requestMaterialType) return;
                    handleRawSalesReferenceError(data?.errDescription);
                },
            },
            true
        );
    }

    function valueChanged(columnId, value, edit) {
        if (columnId === "ZSK_SOKOKBN" && edit === true) {
            validateRawSupplyLocation(value);
        }
        if (columnId === "ZSK_SANMOTODENKBN"
            && isInsertForm
            && edit === true) {
            ++props.rawPurchaseReferenceRequestRef.current;
            ++props.rawSupplyReferenceRequestRef.current;
            ++ssdHeaderRequestRef.current;
            lastSuccessfulSsdNoRef.current = "";
            const referenceSource = normalizeConditionValue(value);
            const slipType = REFERENCE_SOURCE_SLIP_TYPES[referenceSource] || "";
            updateEntryData(nextData => {
                nextData.ZSK_SANMOTODENKBN = referenceSource;
                nextData.ZSK_DENSYUBETU = slipType;
                nextData.ZSKM_DENSYUBETU = slipType;
                REFERENCE_SOURCE_CLEAR_COLUMNS.forEach(clearColumnId => {
                    nextData[clearColumnId] = "";
                });
                clearSsdLinkedHeaderValues(nextData);
            });
            refreshRawSupplyHeader();
            props.resetReferenceSourceDetail();
            return;
        }
        if (columnId === "ZSK_SANMOTODENNO"
            && isInsertForm
            && edit === true
            && normalizeConditionValue(props.entrydataRef.current?.ZSK_SANMOTODENKBN) === "1"
            && ["0", "1", "2"].includes(activeMaterialType)) {
            const referenceNo = normalizeConditionValue(value);
            ++props.rawPurchaseReferenceRequestRef.current;
            if (referenceNo === "") {
                clearRawPurchaseReferenceValues("");
                return;
            }
            if (referenceNo.length < 8) return;
            if (!/^[0-9]{8}$/.test(referenceNo)) {
                clearRawPurchaseReferenceValues("");
                dispatch(warnmsg("参照元伝票番号は8桁の半角数字で入力してください。"));
                return;
            }

            clearRawPurchaseReferenceValues(referenceNo);
            getRawPurchaseReferenceInfo(referenceNo, activeMaterialType);
            return;
        }
        if (columnId === "ZSK_SANMOTODENNO"
            && isInsertForm
            && edit === true
            && normalizeConditionValue(props.entrydataRef.current?.ZSK_SANMOTODENKBN) === "2"
            && ["0", "1", "2"].includes(activeMaterialType)) {
            const referenceNo = normalizeConditionValue(value);
            ++props.rawSupplyReferenceRequestRef.current;
            if (referenceNo === "") {
                clearRawSupplyReferenceValues("");
                return;
            }
            if (referenceNo.length < 8) return;
            if (!/^[0-9]{8}$/.test(referenceNo)) {
                clearRawSupplyReferenceValues("");
                dispatch(warnmsg("参照元伝票番号は8桁の半角数字で入力してください。"));
                return;
            }

            clearRawSupplyReferenceValues(referenceNo);
            getRawSupplyReferenceInfo(referenceNo, activeMaterialType);
            return;
        }
        if (columnId === "ZSK_SANMOTODENNO"
            && isInsertForm
            && edit === true
            && normalizeConditionValue(props.entrydataRef.current?.ZSK_SANMOTODENKBN) === "3"
            && ["0", "1", "2"].includes(activeMaterialType)) {
            const referenceNo = normalizeConditionValue(value);
            ++props.rawSupplyReferenceRequestRef.current;
            if (referenceNo === "") {
                clearRawSupplyReferenceValues("");
                return;
            }
            if (referenceNo.length < 8) return;
            if (!/^[0-9]{8}$/.test(referenceNo)) {
                clearRawSupplyReferenceValues("");
                dispatch(warnmsg("参照元伝票番号は8桁の半角数字で入力してください。"));
                return;
            }

            clearRawSupplyReferenceValues(referenceNo);
            getRawSalesReferenceInfo(referenceNo, activeMaterialType);
            return;
        }
        if (columnId === "ZSK_SANMOTODENKBN" || columnId === "ZSK_KAIGAIKBN") {
            setTextFields(current => applyRawSupplyHeaderDefinitions(
                current,
                Array.isArray(props.columns) ? props.columns : [],
                props.entrydataRef.current,
                formStatus,
                activeMaterialType
            ));
        }
        if (columnId === "ZSK_SIKYUBI"
            && isInsertForm
            && edit === true) {
            const entryData = props.entrydataRef.current || {};
            const ssdNo = normalizeConditionValue(entryData[SSD_NUMBER_COLUMN]);
            const brandCode = normalizeConditionValue(entryData.ZSK_BRDCD);
            const supplyDate = normalizeConditionValue(value);
            updateEntryData(nextData => {
                nextData.ZSK_SHANAIRATE = "";
            });
            refreshRawSupplyHeader();

            if (!/^[0-9]{8}$/.test(ssdNo)
                || brandCode === ""
                || supplyDate === "") {
                ++ssdHeaderRequestRef.current;
                return;
            }

            const materialPurchaseReference = activeMaterialType === "0"
                && normalizeConditionValue(entryData.ZSK_ZAIRYOKBN) === "0"
                && normalizeConditionValue(entryData.ZSK_SANMOTODENKBN) === "1";
            const accessoryPurchaseReference = activeMaterialType === "1"
                && normalizeConditionValue(entryData.ZSK_ZAIRYOKBN) === "1"
                && normalizeConditionValue(entryData.ZSK_SANMOTODENKBN) === "1";
            const submaterialPurchaseReference = activeMaterialType === "2"
                && normalizeConditionValue(entryData.ZSK_ZAIRYOKBN) === "2"
                && normalizeConditionValue(entryData.ZSK_SANMOTODENKBN) === "1";
            getSsdHeaderInfo(
                ssdNo,
                brandCode,
                supplyDate,
                materialPurchaseReference
                    || accessoryPurchaseReference
                    || submaterialPurchaseReference
                    ? {
                        materialPurchaseReference: materialPurchaseReference,
                        accessoryPurchaseReference: accessoryPurchaseReference,
                        submaterialPurchaseReference: submaterialPurchaseReference,
                    }
                    : undefined
            );
            return;
        }
        if (columnId === "ZSK_BRDCD"
            && isInsertForm
            && edit === true) {
            ++ssdHeaderRequestRef.current;
            lastSuccessfulSsdNoRef.current = "";
            updateEntryData(nextData => {
                nextData[SSD_NUMBER_COLUMN] = "";
                clearSsdLinkedHeaderValues(nextData);
                clearInvoiceValues(nextData);
            });
            refreshRawSupplyHeader();
            return;
        }
        if (columnId !== SSD_NUMBER_COLUMN
            || !isInsertForm
            || edit !== true) return;

        const entryData = props.entrydataRef.current || {};
        const ssdNo = normalizeConditionValue(
            entryData[SSD_NUMBER_COLUMN] ?? value
        );
        if (ssdNo === "") {
            ++ssdHeaderRequestRef.current;
            lastSuccessfulSsdNoRef.current = "";
            updateEntryData(nextData => {
                clearSsdLinkedHeaderValues(nextData);
                clearInvoiceValues(nextData);
            });
            refreshRawSupplyHeader();
            return;
        }

        if (ssdNo.length < 8) {
            ++ssdHeaderRequestRef.current;
            return;
        }

        if (!/^[0-9]{8}$/.test(ssdNo)) {
            ++ssdHeaderRequestRef.current;
            restoreSsdHeaderAfterError();
            dispatch(warnmsg("加工指示番号は8桁の半角数字で入力してください。"));
            return;
        }

        const brandCode = normalizeConditionValue(entryData.ZSK_BRDCD);
        if (brandCode === "") {
            ++ssdHeaderRequestRef.current;
            restoreSsdHeaderAfterError();
            dispatch(warnmsg("ブランドを先に入力してください。"));
            return;
        }

        getSsdHeaderInfo(
            ssdNo,
            brandCode,
            normalizeConditionValue(entryData.ZSK_SIKYUBI)
        );
    }

    function handleSsdNumberBlur(event) {
        if (event.target.id !== SSD_NUMBER_COLUMN + "_102"
            || !isInsertForm) return;

        const ssdNo = normalizeConditionValue(
            props.entrydataRef.current?.[SSD_NUMBER_COLUMN]
        );
        if (ssdNo === "" || ssdNo.length >= 8) return;

        ++ssdHeaderRequestRef.current;
        restoreSsdHeaderAfterError();
        dispatch(warnmsg("加工指示番号は8桁の半角数字で入力してください。"));
    }

    function handleInvoiceBlur(event, panelType) {
        if (!isInsertForm
            || normalizeConditionValue(props.entrydataRef.current?.ZSK_KAIGAIKBN) !== "2") return;

        const columnId = INVOICE_COLUMNS.find(
            id => event.target.id === id + "_" + panelType
        );
        if (columnId === undefined) return;

        const field = textFields.find(
            item => item.type === panelType && item.columnid === columnId
        );
        if (field === undefined || field.locked) return;

        const value = event.target.value === null || event.target.value === undefined
            ? ""
            : String(event.target.value);
        if (value === "") return;

        if (columnId === "ZSK_INVOICENO" && !/^[0-9]{1,20}$/.test(value)) {
            dispatch(warnmsg("Invoice Noは20桁以内の半角数字で入力してください。"));
        } else if (columnId === "ZSK_INVOICEEDA" && !/^[0-9]{4}$/.test(value)) {
            dispatch(warnmsg("Invoice枝番は4桁の半角数字で入力してください。"));
        }
    }

    function handleRawSupplyHeaderBlur(event, panelType) {
        handleSsdNumberBlur(event);
        handleInvoiceBlur(event, panelType);
    }

    function getMaterialSelectionRequestState(rowNode) {
        let requestState = materialSelectionRequestRef.current.get(rowNode);
        if (requestState === undefined) {
            requestState = { material: 0, color: 0, cost: 0 };
            materialSelectionRequestRef.current.set(rowNode, requestState);
        }
        return requestState;
    }

    function isCurrentMaterialSelectionRequest(
        targetRefs,
        rowNode,
        sourceRowId,
        request,
        requestType,
        requestNo
    ) {
        const api = targetRefs?.api;
        if (api === null || api === undefined) return false;
        if (typeof api.isDestroyed === "function" && api.isDestroyed()) return false;
        if (api.getRowNode(sourceRowId) !== rowNode) return false;

        const requestState = materialSelectionRequestRef.current.get(rowNode);
        if (requestState === undefined || requestState[requestType] !== requestNo) return false;
        const entryData = props.entrydataRef.current || {};
        if (normalizeConditionValue(entryData.ZSK_BRDCD) !== request.brandCode) return false;
        if (normalizeConditionValue(rowNode.data.ZSKM_ZAISIIRESAKIKBN)
            !== request.supplierType) return false;
        if (normalizeConditionValue(rowNode.data.ZSKM_ZAISIIRESAKICD)
            !== request.supplierCode) return false;
        if (normalizeConditionValue(rowNode.data.ZSKM_ZAISIIRESAKISUBCD)
            !== request.supplierSubCode) return false;
        if (normalizeConditionValue(rowNode.data[MATERIAL_ITEM_NUMBER_COLUMN])
            !== request.materialItemNumber) return false;
        if (normalizeConditionValue(entryData.ZSK_SANMOTODENKBN)
            !== request.referenceType) return false;
        if (requestType === "color"
            && normalizeConditionValue(rowNode.data[MATERIAL_COLOR_COLUMN])
                !== request.colorCode) return false;
        return true;
    }

    function getFzkSelectionRequestState(rowNode) {
        let requestState = fzkSelectionRequestRef.current.get(rowNode);
        if (requestState === undefined) {
            requestState = { item: 0, color: 0 };
            fzkSelectionRequestRef.current.set(rowNode, requestState);
        }
        return requestState;
    }

    function isCurrentFzkSelectionRequest(
        targetRefs,
        rowNode,
        sourceRowId,
        request,
        requestType,
        requestNo
    ) {
        const api = targetRefs?.api;
        if (api === null || api === undefined) return false;
        if (typeof api.isDestroyed === "function" && api.isDestroyed()) return false;
        if (api.getRowNode(sourceRowId) !== rowNode) return false;

        const requestState = fzkSelectionRequestRef.current.get(rowNode);
        if (requestState === undefined || requestState[requestType] !== requestNo) return false;
        const entryData = props.entrydataRef.current || {};
        if (normalizeConditionValue(entryData.ZSK_BRDCD) !== request.brandCode) return false;
        if (normalizeConditionValue(entryData.ZSK_SANMOTODENKBN)
            !== request.referenceType) return false;
        if (normalizeConditionValue(rowNode.data.ZSKM_ZAISIIRESAKIKBN)
            !== request.supplierType) return false;
        if (normalizeConditionValue(rowNode.data.ZSKM_ZAISIIRESAKICD)
            !== request.supplierCode) return false;
        if (normalizeConditionValue(rowNode.data.ZSKM_ZAISIIRESAKISUBCD)
            !== request.supplierSubCode) return false;
        if (normalizeConditionValue(rowNode.data[MATERIAL_ITEM_NUMBER_COLUMN])
            !== request.itemNumber) return false;
        if (requestType === "color"
            && normalizeConditionValue(rowNode.data[MATERIAL_COLOR_COLUMN])
                !== request.colorCode) return false;
        return true;
    }

    function isCurrentMaterialCostRequest(
        targetRefs,
        rowNode,
        sourceRowId,
        request,
        requestNo
    ) {
        const api = targetRefs?.api;
        if (api === null || api === undefined) return false;
        if (typeof api.isDestroyed === "function" && api.isDestroyed()) return false;
        if (api.getRowNode(sourceRowId) !== rowNode) return false;

        const requestState = materialSelectionRequestRef.current.get(rowNode);
        if (requestState === undefined || requestState.cost !== requestNo) return false;
        const entryData = props.entrydataRef.current || {};
        if (normalizeConditionValue(entryData.ZSK_SIKYUBI) !== request.supplyDate) return false;
        if (normalizeConditionValue(entryData.ZSK_BRDCD) !== request.brandCode) return false;
        if (normalizeConditionValue(entryData.ZSK_SIKYUMOTOCD) !== request.ownerCode) return false;
        if (normalizeConditionValue(rowNode.data.ZSKM_ZAISIIRESAKIKBN)
            !== request.supplierType) return false;
        if (normalizeConditionValue(rowNode.data.ZSKM_ZAISIIRESAKICD)
            !== request.supplierCode) return false;
        if (normalizeConditionValue(rowNode.data.ZSKM_ZAISIIRESAKISUBCD)
            !== request.supplierSubCode) return false;
        if (normalizeConditionValue(rowNode.data[MATERIAL_ITEM_NUMBER_COLUMN])
            !== request.materialItemNumber) return false;
        if (normalizeConditionValue(rowNode.data[MATERIAL_COLOR_COLUMN])
            !== request.colorCode) return false;
        if (normalizeConditionValue(rowNode.data.ZSKM_MEKERCOLORNO)
            !== request.makerColorCode) return false;
        if (normalizeConditionValue(entryData.ZSK_KAIGAIKBN)
            !== request.overseasType) return false;
        if (normalizeConditionValue(entryData.ZSK_SIKYUKBN)
            !== request.supplyType) return false;
        if (normalizeConditionValue(entryData.ZSK_TSUKATANI)
            !== request.currencyUnit) return false;
        if (normalizeConditionValue(entryData.ZSK_SHANAIRATE)
            !== request.exchangeRate) return false;
        if (normalizeConditionValue(entryData.ZSK_SANMOTODENKBN)
            !== request.referenceType) return false;
        return true;
    }

    function invalidateAccessoryCostRequest(rowNode) {
        const requestNo = (accessoryCostRequestRef.current.get(rowNode) ?? 0) + 1;
        accessoryCostRequestRef.current.set(rowNode, requestNo);
        return requestNo;
    }

    function isCurrentAccessoryCostRequest(
        targetRefs,
        rowNode,
        sourceRowId,
        requestContext,
        requestNo
    ) {
        const api = targetRefs?.api;
        if (api === null || api === undefined) return false;
        if (typeof api.isDestroyed === "function" && api.isDestroyed()) return false;
        if (api.getRowNode(sourceRowId) !== rowNode) return false;
        if (accessoryCostRequestRef.current.get(rowNode) !== requestNo) return false;

        const entryData = props.entrydataRef.current || {};
        if (normalizeConditionValue(entryData.ZSK_SIKYUBI)
            !== requestContext.supplyDate) return false;
        if (normalizeConditionValue(entryData.ZSK_BRDCD)
            !== requestContext.brandCode) return false;
        if (normalizeConditionValue(entryData.ZSK_SIKYUMOTOCD)
            !== requestContext.ownerCode) return false;
        if (normalizeConditionValue(rowNode.data.ZSKM_ZAISIIRESAKIKBN)
            !== requestContext.supplierType) return false;
        if (normalizeConditionValue(rowNode.data.ZSKM_ZAISIIRESAKICD)
            !== requestContext.supplierCode) return false;
        if (normalizeConditionValue(rowNode.data.ZSKM_ZAISIIRESAKISUBCD)
            !== requestContext.supplierSubCode) return false;
        if (normalizeConditionValue(rowNode.data[MATERIAL_ITEM_NUMBER_COLUMN])
            !== requestContext.accessoryItemNumber) return false;
        if (normalizeConditionValue(rowNode.data[MATERIAL_COLOR_COLUMN])
            !== requestContext.colorCode) return false;
        if (normalizeConditionValue(rowNode.data.ZSKM_MEKERCOLORNO)
            !== requestContext.makerColorCode) return false;
        if (normalizeConditionValue(entryData.ZSK_KAIGAIKBN)
            !== requestContext.overseasType) return false;
        if (normalizeConditionValue(entryData.ZSK_SIKYUKBN)
            !== requestContext.supplyType) return false;
        if (normalizeConditionValue(entryData.ZSK_TSUKATANI)
            !== requestContext.currencyUnit) return false;
        if (normalizeConditionValue(entryData.ZSK_SHANAIRATE)
            !== requestContext.exchangeRate) return false;
        if (normalizeConditionValue(entryData.ZSK_SANMOTODENKBN)
            !== requestContext.referenceType) return false;
        return true;
    }

    function invalidateSubmaterialCostRequest(rowNode) {
        const requestNo = (submaterialCostRequestRef.current.get(rowNode) ?? 0) + 1;
        submaterialCostRequestRef.current.set(rowNode, requestNo);
        return requestNo;
    }

    function isCurrentSubmaterialCostRequest(
        targetRefs,
        rowNode,
        sourceRowId,
        requestContext,
        requestNo
    ) {
        const api = targetRefs?.api;
        if (api === null || api === undefined) return false;
        if (typeof api.isDestroyed === "function" && api.isDestroyed()) return false;
        if (api.getRowNode(sourceRowId) !== rowNode) return false;
        if (submaterialCostRequestRef.current.get(rowNode) !== requestNo) return false;

        const entryData = props.entrydataRef.current || {};
        if (normalizeConditionValue(entryData.ZSK_SIKYUBI)
            !== requestContext.supplyDate) return false;
        if (normalizeConditionValue(entryData.ZSK_BRDCD)
            !== requestContext.brandCode) return false;
        if (normalizeConditionValue(entryData.ZSK_SIKYUMOTOCD)
            !== requestContext.ownerCode) return false;
        if (normalizeConditionValue(rowNode.data.ZSKM_ZAISIIRESAKIKBN)
            !== requestContext.supplierType) return false;
        if (normalizeConditionValue(rowNode.data.ZSKM_ZAISIIRESAKICD)
            !== requestContext.supplierCode) return false;
        if (normalizeConditionValue(rowNode.data.ZSKM_ZAISIIRESAKISUBCD)
            !== requestContext.supplierSubCode) return false;
        if (normalizeConditionValue(rowNode.data[MATERIAL_ITEM_NUMBER_COLUMN])
            !== requestContext.submaterialItemNumber) return false;
        if (normalizeConditionValue(rowNode.data[MATERIAL_COLOR_COLUMN])
            !== requestContext.colorCode) return false;
        if (normalizeConditionValue(entryData.ZSK_KAIGAIKBN)
            !== requestContext.overseasType) return false;
        if (normalizeConditionValue(entryData.ZSK_SIKYUKBN)
            !== requestContext.supplyType) return false;
        if (normalizeConditionValue(entryData.ZSK_TSUKATANI)
            !== requestContext.currencyUnit) return false;
        if (normalizeConditionValue(entryData.ZSK_SHANAIRATE)
            !== requestContext.exchangeRate) return false;
        if (normalizeConditionValue(entryData.ZSK_SANMOTODENKBN)
            !== requestContext.referenceType) return false;
        return true;
    }

    function refreshMaterialTotalRows(targetRefs) {
        const panel = materialPanels.find(item => {
            if (item.type !== MATERIAL_DETAIL_PANEL_TYPE) return false;
            const detailKey = item.id + "_" + item.type + "_" + props.entryDetailResetKey;
            return gridRefs.current[detailKey] === targetRefs;
        });
        if (panel === undefined) return;

        const totalType = getTotalType(panel);
        if (totalType === "") return;
        const totalKey = "T" + panel.id + "_" + totalType + "_" + props.entryDetailResetKey;
        const totalRefs = gridRefs.current[totalKey];
        if (totalRefs === undefined) return;

        totalRefs.dataRef.current = buildTotalRows(totalType, targetRefs.dataRef.current);
        props.fnc.current.rerenderGrid(props.fnc.current.GridID("T" + panel.id));
    }

    function refreshAccessoryTotalRows(targetRefs) {
        const panel = materialPanels.find(item => {
            if (item.type !== ACCESSORY_DETAIL_PANEL_TYPE) return false;
            const detailKey = item.id + "_" + item.type + "_" + props.entryDetailResetKey;
            return gridRefs.current[detailKey] === targetRefs;
        });
        if (panel === undefined) return;

        const totalType = getTotalType(panel);
        if (totalType === "") return;
        const totalKey = "T" + panel.id + "_" + totalType + "_" + props.entryDetailResetKey;
        const totalRefs = gridRefs.current[totalKey];
        if (totalRefs === undefined) return;

        totalRefs.dataRef.current = buildTotalRows(totalType, targetRefs.dataRef.current);
        props.fnc.current.rerenderGrid(props.fnc.current.GridID("T" + panel.id));
    }

    function refreshSubmaterialTotalRows(targetRefs) {
        const panel = materialPanels.find(item => {
            if (item.type !== SUBMATERIAL_DETAIL_PANEL_TYPE) return false;
            const detailKey = item.id + "_" + item.type + "_" + props.entryDetailResetKey;
            return gridRefs.current[detailKey] === targetRefs;
        });
        if (panel === undefined) return;

        const totalType = getTotalType(panel);
        if (totalType === "") return;
        const totalKey = "T" + panel.id + "_" + totalType + "_" + props.entryDetailResetKey;
        const totalRefs = gridRefs.current[totalKey];
        if (totalRefs === undefined) return;

        totalRefs.dataRef.current = buildTotalRows(totalType, targetRefs.dataRef.current);
        props.fnc.current.rerenderGrid(props.fnc.current.GridID("T" + panel.id));
    }

    function getMaterialSelectionInfo(
        targetRefs,
        rowNode,
        sourceRowId,
        requestType,
        currentMakerColorCode
    ) {
        const requestState = getMaterialSelectionRequestState(rowNode);
        const requestNo = ++requestState[requestType];
        const entryData = props.entrydataRef.current || {};
        const request = {
            brandCode: normalizeConditionValue(entryData.ZSK_BRDCD),
            supplierType: normalizeConditionValue(rowNode.data.ZSKM_ZAISIIRESAKIKBN),
            supplierCode: normalizeConditionValue(rowNode.data.ZSKM_ZAISIIRESAKICD),
            supplierSubCode: normalizeConditionValue(rowNode.data.ZSKM_ZAISIIRESAKISUBCD),
            materialItemNumber: normalizeConditionValue(
                rowNode.data[MATERIAL_ITEM_NUMBER_COLUMN]
            ),
            colorCode: requestType === "color"
                ? normalizeConditionValue(rowNode.data[MATERIAL_COLOR_COLUMN])
                : "",
            currentMakerColorCode: normalizeConditionValue(currentMakerColorCode),
            referenceType: normalizeConditionValue(entryData.ZSK_SANMOTODENKBN),
        };

        props.fnc.current.postaxios(
            'RawSupplyIn/GetMaterialSelectionInfo',
            { data: request },
            {
                onSuccess: function (data) {
                    if (!isCurrentMaterialSelectionRequest(
                        targetRefs,
                        rowNode,
                        sourceRowId,
                        request,
                        requestType,
                        requestNo
                    )) return;
                    if (data.rowdata === null || data.rowdata === undefined) {
                        dispatch(warnmsg("素材マスタ情報を取得できません。"));
                        return;
                    }

                    rowNode.data[MATERIAL_MAKER_ITEM_NUMBER_COLUMN] =
                        data.rowdata.ZAI_MEKERHBN ?? "";
                    rowNode.data.ZAI_KIKAKUE = data.rowdata.ZAI_KIKAKUE ?? "";
                    calculateMaterialSupplyRollCount(rowNode.data);
                    const refreshColumns = [
                        MATERIAL_MAKER_ITEM_NUMBER_COLUMN,
                        "ZAI_KIKAKUE",
                        "ZSKM_SIKYUTANSU",
                    ];
                    if (requestType === "color") {
                        rowNode.data[MATERIAL_COLOR_COLUMN + "_nm"] =
                            data.rowdata.ZSKM_ZAICOLORCD_nm ?? "";
                        rowNode.data.ZSKM_MEKERCOLORNO =
                            data.rowdata.ZSKM_MEKERCOLORNO ?? "";
                        rowNode.data.ZSKM_MEKERCOLORNO_nm =
                            data.rowdata.ZSKM_MEKERCOLORNO_nm ?? "";
                        refreshColumns.push(
                            MATERIAL_COLOR_COLUMN + "_nm",
                            "ZSKM_MEKERCOLORNO",
                            "ZSKM_MEKERCOLORNO_nm"
                        );
                    }
                    targetRefs.api.refreshCells({
                        rowNodes: [rowNode],
                        columns: refreshColumns,
                        force: true,
                    });
                    if (requestType === "color") {
                        getMaterialCostInfo(
                            targetRefs,
                            rowNode,
                            sourceRowId,
                            {
                                baseForeignUnitPrice:
                                    data.rowdata.INITIAL_FOREIGN_UNIT_PRICE ?? 0,
                                supplyUpliftRate:
                                    data.rowdata.SUPPLY_UPLIFT_RATE ?? 0,
                            }
                        );
                    }
                },
                onError: function (data) {
                    if (!isCurrentMaterialSelectionRequest(
                        targetRefs,
                        rowNode,
                        sourceRowId,
                        request,
                        requestType,
                        requestNo
                    )) return;
                    dispatch(warnmsg(
                        normalizeConditionValue(data?.errDescription)
                        || "素材マスタ情報を取得できません。"
                    ));
                },
            },
            true
        );
    }

    function getFzkSelectionInfo(
        targetRefs,
        rowNode,
        sourceRowId,
        panelType,
        requestType
    ) {
        const requestState = getFzkSelectionRequestState(rowNode);
        const requestNo = ++requestState[requestType];
        const entryData = props.entrydataRef.current || {};
        const request = {
            materialType: panelType === ACCESSORY_DETAIL_PANEL_TYPE ? "1" : "2",
            brandCode: normalizeConditionValue(entryData.ZSK_BRDCD),
            supplierType: normalizeConditionValue(rowNode.data.ZSKM_ZAISIIRESAKIKBN),
            supplierCode: normalizeConditionValue(rowNode.data.ZSKM_ZAISIIRESAKICD),
            supplierSubCode: normalizeConditionValue(rowNode.data.ZSKM_ZAISIIRESAKISUBCD),
            itemNumber: normalizeConditionValue(rowNode.data[MATERIAL_ITEM_NUMBER_COLUMN]),
            colorCode: requestType === "color"
                ? normalizeConditionValue(rowNode.data[MATERIAL_COLOR_COLUMN])
                : "",
            referenceType: normalizeConditionValue(entryData.ZSK_SANMOTODENKBN),
        };
        if (request.referenceType !== ""
            || request.brandCode === ""
            || request.supplierType === ""
            || request.supplierCode === ""
            || request.supplierSubCode === ""
            || request.itemNumber === ""
            || (requestType === "color" && request.colorCode === "")) return;

        props.fnc.current.postaxios(
            'RawSupplyIn/GetFzkSelectionInfo',
            { data: request },
            {
                onSuccess: function (data) {
                    if (!isCurrentFzkSelectionRequest(
                        targetRefs,
                        rowNode,
                        sourceRowId,
                        request,
                        requestType,
                        requestNo
                    )) return;
                    if (data.rowdata === null || data.rowdata === undefined) {
                        dispatch(warnmsg(
                            requestType === "color"
                                ? "附属・副資材カラーマスタ情報を取得できません。"
                                : "附属・副資材マスタ情報を取得できません。"
                        ));
                        return;
                    }

                    if (requestType === "color") {
                        rowNode.data[MATERIAL_COLOR_COLUMN + "_cd"] = request.colorCode;
                        rowNode.data[MATERIAL_COLOR_COLUMN + "_nm"] =
                            data.rowdata.FZKC_FCOLORNM ?? "";
                        rowNode.data.ZSKM_MEKERCOLORNO =
                            data.rowdata.FZKC_SIRE_COLORCD ?? "";
                        rowNode.data.ZSKM_MEKERCOLORNO_nm =
                            data.rowdata.FZKC_SIRE_COLORNM ?? "";
                        targetRefs.api.refreshCells({
                            rowNodes: [rowNode],
                            columns: [
                                MATERIAL_COLOR_COLUMN,
                                MATERIAL_COLOR_COLUMN + "_cd",
                                MATERIAL_COLOR_COLUMN + "_nm",
                                "ZSKM_MEKERCOLORNO",
                                "ZSKM_MEKERCOLORNO_nm",
                            ],
                            force: true,
                        });
                        if (panelType === ACCESSORY_DETAIL_PANEL_TYPE) {
                            getAccessoryCostInfo(targetRefs, rowNode, sourceRowId);
                        } else if (panelType === SUBMATERIAL_DETAIL_PANEL_TYPE) {
                            const costRequestNo = invalidateSubmaterialCostRequest(rowNode);
                            getSubmaterialCostInfo(
                                targetRefs,
                                rowNode,
                                sourceRowId,
                                costRequestNo
                            );
                        }
                        return;
                    }

                    rowNode.data.ZSKM_ZAISIIRESAKIKBN =
                        data.rowdata.FZK_TORKUBUN ?? "";
                    rowNode.data.ZSKM_ZAISIIRESAKISUBCD =
                        data.rowdata.FZK_TORSUBCODE ?? "";
                    rowNode.data.FZK_FUZOKU_NM = data.rowdata.FZK_FUZOKU_NM ?? "";
                    rowNode.data.FZK_SIREFUZOKU_HBN =
                        data.rowdata.FZK_SIREFUZOKU_HBN ?? "";
                    rowNode.data.ZSKM_ZAISIZECD = "*";
                    rowNode.data.ZSKM_TANI = data.rowdata.FZK_TANI ?? "";
                    const refreshColumns = [
                        "ZSKM_ZAISIIRESAKIKBN",
                        "ZSKM_ZAISIIRESAKISUBCD",
                        "FZK_FUZOKU_NM",
                        "FZK_SIREFUZOKU_HBN",
                        "ZSKM_ZAISIZECD",
                        "ZSKM_TANI",
                    ];
                    if (panelType === ACCESSORY_DETAIL_PANEL_TYPE) {
                        rowNode.data.FZK_FUZOKU_SIZE =
                            data.rowdata.FZK_FUZOKU_SIZE ?? "";
                        rowNode.data.FZK_SIREFUZOKU_SIZE =
                            data.rowdata.FZK_SIREFUZOKU_SIZE ?? "";
                        refreshColumns.push("FZK_FUZOKU_SIZE", "FZK_SIREFUZOKU_SIZE");
                    }
                    targetRefs.api.refreshCells({
                        rowNodes: [rowNode],
                        columns: refreshColumns,
                        force: true,
                    });
                    if (panelType === SUBMATERIAL_DETAIL_PANEL_TYPE) {
                        const costRequestNo = invalidateSubmaterialCostRequest(rowNode);
                        getSubmaterialCostInfo(
                            targetRefs,
                            rowNode,
                            sourceRowId,
                            costRequestNo
                        );
                    }
                },
                onError: function (data) {
                    if (!isCurrentFzkSelectionRequest(
                        targetRefs,
                        rowNode,
                        sourceRowId,
                        request,
                        requestType,
                        requestNo
                    )) return;
                    dispatch(warnmsg(
                        normalizeConditionValue(data?.errDescription)
                        || "附属・副資材マスタ情報を取得できません。"
                    ));
                },
            },
            true
        );
    }

    function applyInitialMaterialUnitPrice(rowData, cost, request, unitPriceContext) {
        if (request.referenceType !== "") return false;

        rowData.ZSKM_TANKA = "";
        rowData.ZSKM_TANKAF = "";
        if (request.overseasType === "1") {
            rowData.ZSKM_TANKA = cost;
            rowData.ZSKM_TANKAF = 0;
            return false;
        }
        if (request.overseasType !== "2") return false;
        if (request.supplyType === "2") {
            rowData.ZSKM_TANKA = cost;
            return false;
        }
        if (request.supplyType !== "1") return false;

        const currencyUnit = request.currencyUnit.toUpperCase();
        if (currencyUnit === "JPY") {
            rowData.ZSKM_TANKA = cost;
            rowData.ZSKM_TANKAF = 0;
            return false;
        }
        if (currencyUnit === "") return false;

        const exchangeRate = Number(request.exchangeRate);
        if (request.exchangeRate === ""
            || !Number.isFinite(exchangeRate)
            || exchangeRate <= 0) return true;

        const foreignPrice = GetDesitRound(
            NumConv(unitPriceContext?.baseForeignUnitPrice)
                * (1 + NumConv(unitPriceContext?.supplyUpliftRate)),
            1,
            2
        );
        rowData.ZSKM_TANKAF = foreignPrice;
        rowData.ZSKM_TANKA = GetDesitRound(foreignPrice * exchangeRate, 1, 2);
        return false;
    }

    function calculateDetailAmounts(rowData, quantityColumn, entryData) {
        const roundingType = {
            "1": 0,
            "2": 2,
            "3": 1,
        }[normalizeConditionValue(entryData.ZAI_MEI_HASU)];
        const yenDecimalPlaces = {
            "1": 0,
            "2": 1,
            "3": 2,
        }[normalizeConditionValue(entryData.ZAI_MEI_HASU_POSITION)];
        if (roundingType === undefined || yenDecimalPlaces === undefined) return false;

        const quantity = NumConv(rowData[quantityColumn]);
        rowData.ZSKM_KINGAKU = GetDesitRound(
            quantity * NumConv(rowData[YEN_UNIT_PRICE_COLUMN]),
            roundingType,
            yenDecimalPlaces
        );
        rowData.ZSKM_KINGAKUF = GetDesitRound(
            quantity * NumConv(rowData[FOREIGN_CURRENCY_UNIT_PRICE_COLUMN]),
            roundingType,
            2
        );
        rowData.ZSKM_KINGAKUZ = rowData.ZSKM_KINGAKU;
        return true;
    }

    function calculateMaterialSupplyRollCount(rowData) {
        const quantityValue = normalizeConditionValue(rowData.ZSKM_SIKYUMETERSU);
        const standardLengthValue = normalizeConditionValue(rowData.ZAI_KIKAKUE);
        const quantity = Number(quantityValue);
        const standardLength = Number(standardLengthValue);
        rowData.ZSKM_SIKYUTANSU = quantityValue !== ""
            && Number.isFinite(quantity)
            && standardLengthValue !== ""
            && Number.isFinite(standardLength)
            && standardLength > 0
            ? GetDesitRound(quantity / standardLength, 2, 1)
            : 0;
    }

    function buildCopyCostRequest(rowNode) {
        const entryData = props.entrydataRef.current || {};
        const request = {
            supplyDate: normalizeConditionValue(entryData.ZSK_SIKYUBI),
            brandCode: normalizeConditionValue(entryData.ZSK_BRDCD),
            ownerCode: normalizeConditionValue(entryData.ZSK_SIKYUMOTOCD),
            supplierType: normalizeConditionValue(rowNode.data.ZSKM_ZAISIIRESAKIKBN),
            supplierCode: normalizeConditionValue(rowNode.data.ZSKM_ZAISIIRESAKICD),
            supplierSubCode: normalizeConditionValue(rowNode.data.ZSKM_ZAISIIRESAKISUBCD),
        };
        if (activeMaterialType === "0") {
            return {
                ...request,
                materialItemNumber: normalizeConditionValue(
                    rowNode.data[MATERIAL_ITEM_NUMBER_COLUMN]
                ),
                colorCode: normalizeConditionValue(rowNode.data[MATERIAL_COLOR_COLUMN]),
                makerColorCode: normalizeConditionValue(rowNode.data.ZSKM_MEKERCOLORNO),
            };
        }
        if (activeMaterialType === "1") {
            return {
                ...request,
                accessoryItemNumber: normalizeConditionValue(
                    rowNode.data[MATERIAL_ITEM_NUMBER_COLUMN]
                ),
                colorCode: normalizeConditionValue(rowNode.data[MATERIAL_COLOR_COLUMN]),
            };
        }
        return {
            ...request,
            submaterialItemNumber: normalizeConditionValue(
                rowNode.data[MATERIAL_ITEM_NUMBER_COLUMN]
            ),
            colorCode: normalizeConditionValue(
                rowNode.data[MATERIAL_COLOR_COLUMN]
            ),
        };
    }

    function isCurrentCopyCostRequest(targetRefs, rowNode, request, generation) {
        if (copyCostGenerationRef.current !== generation
            || copyCostFormStatusRef.current !== "COPY FORM") return false;
        const api = targetRefs?.api;
        if (api === null || api === undefined) return false;
        if (typeof api.isDestroyed === "function" && api.isDestroyed()) return false;
        if (api.getRowNode(rowNode.id) !== rowNode) return false;

        const currentRequest = buildCopyCostRequest(rowNode);
        return Object.keys(request).every(key => currentRequest[key] === request[key]);
    }

    function refreshCopyCosts(targetRefs, rowNodes, generation) {
        const costConfig = {
            "0": {
                url: "RawSupplyIn/GetMaterialCostInfo",
                warning: "素材原価を取得できません。",
                required: ["supplyDate", "brandCode", "ownerCode", "supplierType",
                    "supplierCode", "supplierSubCode", "materialItemNumber", "colorCode"],
            },
            "1": {
                url: "RawSupplyIn/GetAccessoryCostInfo",
                warning: "附属原価を取得できません。",
                required: ["supplyDate", "brandCode", "ownerCode", "supplierType",
                    "supplierCode", "supplierSubCode", "accessoryItemNumber", "colorCode"],
            },
            "2": {
                url: "RawSupplyIn/GetSubmaterialCostInfo",
                warning: "副資材原価を取得できません。",
                required: ["supplyDate", "brandCode", "ownerCode", "supplierType",
                    "supplierCode", "supplierSubCode", "submaterialItemNumber"],
            },
        }[activeMaterialType];

        rowNodes.forEach(rowNode => {
            rowNode.data.ZSKM_HEIKINTANKA = 0;
        });
        targetRefs.api.refreshCells({
            rowNodes: rowNodes,
            columns: ["ZSKM_HEIKINTANKA"],
            force: true,
        });
        if (rowNodes.length === 0 || costConfig === undefined) return;

        props.fnc.current.wait(true);
        function refreshNext(index) {
            if (copyCostGenerationRef.current !== generation
                || copyCostFormStatusRef.current !== "COPY FORM"
                || index >= rowNodes.length) {
                props.fnc.current.wait(false);
                return;
            }

            const rowNode = rowNodes[index];
            const request = buildCopyCostRequest(rowNode);
            if (costConfig.required.some(key => request[key] === "")) {
                dispatch(warnmsg(costConfig.warning));
                refreshNext(index + 1);
                return;
            }

            props.fnc.current.postaxios(
                costConfig.url,
                { data: request },
                {
                    onSuccess: function (data) {
                        if (isCurrentCopyCostRequest(
                            targetRefs,
                            rowNode,
                            request,
                            generation
                        )) {
                            if (data.rowdata === null || data.rowdata === undefined) {
                                dispatch(warnmsg(costConfig.warning));
                            } else {
                                rowNode.data.ZSKM_HEIKINTANKA =
                                    data.rowdata.ZSKM_HEIKINTANKA ?? 0;
                                targetRefs.api.refreshCells({
                                    rowNodes: [rowNode],
                                    columns: ["ZSKM_HEIKINTANKA"],
                                    force: true,
                                });
                            }
                        }
                        refreshNext(index + 1);
                    },
                    onError: function (data) {
                        if (isCurrentCopyCostRequest(
                            targetRefs,
                            rowNode,
                            request,
                            generation
                        )) {
                            dispatch(warnmsg(
                                normalizeConditionValue(data?.errDescription)
                                || costConfig.warning
                            ));
                        }
                        refreshNext(index + 1);
                    },
                },
                true
            );
        }
        refreshNext(0);
    }

    tryRefreshCopyCostsRef.current = function () {
        if (copyCostFormStatusRef.current !== "COPY FORM"
            || copyCostStartedRef.current) return;
        const panel = materialPanels.find(item => item.type === activePanelTypes.detail);
        if (panel === undefined) return;
        const key = panel.id + "_" + panel.type + "_" + props.entryDetailResetKey;
        const targetRefs = gridRefs.current[key];
        if (targetRefs?.api === null || targetRefs?.api === undefined
            || !Array.isArray(targetRefs.dataRef.current)) return;

        const targetRowCount = targetRefs.dataRef.current.filter(row =>
            normalizeConditionValue(row?.[MATERIAL_ITEM_NUMBER_COLUMN]) !== ""
        ).length;
        const rowNodes = [];
        targetRefs.api.forEachNode(rowNode => {
            if (rowNode?.data === null || rowNode?.data === undefined) return;
            if (normalizeConditionValue(rowNode.data[MATERIAL_ITEM_NUMBER_COLUMN]) === "") return;
            rowNodes.push(rowNode);
        });
        if (rowNodes.length < targetRowCount) return;
        copyCostStartedRef.current = true;
        refreshCopyCosts(targetRefs, rowNodes, copyCostGenerationRef.current);
    };

    function getMaterialCostInfo(targetRefs, rowNode, sourceRowId, unitPriceContext) {
        const entryData = props.entrydataRef.current || {};
        const request = {
            supplyDate: normalizeConditionValue(entryData.ZSK_SIKYUBI),
            brandCode: normalizeConditionValue(entryData.ZSK_BRDCD),
            ownerCode: normalizeConditionValue(entryData.ZSK_SIKYUMOTOCD),
            supplierType: normalizeConditionValue(rowNode.data.ZSKM_ZAISIIRESAKIKBN),
            supplierCode: normalizeConditionValue(rowNode.data.ZSKM_ZAISIIRESAKICD),
            supplierSubCode: normalizeConditionValue(rowNode.data.ZSKM_ZAISIIRESAKISUBCD),
            materialItemNumber: normalizeConditionValue(
                rowNode.data[MATERIAL_ITEM_NUMBER_COLUMN]
            ),
            colorCode: normalizeConditionValue(rowNode.data[MATERIAL_COLOR_COLUMN]),
            makerColorCode: normalizeConditionValue(rowNode.data.ZSKM_MEKERCOLORNO),
            overseasType: normalizeConditionValue(entryData.ZSK_KAIGAIKBN),
            supplyType: normalizeConditionValue(entryData.ZSK_SIKYUKBN),
            currencyUnit: normalizeConditionValue(entryData.ZSK_TSUKATANI),
            exchangeRate: normalizeConditionValue(entryData.ZSK_SHANAIRATE),
            referenceType: normalizeConditionValue(entryData.ZSK_SANMOTODENKBN),
        };
        if (request.supplyDate === ""
            || request.brandCode === ""
            || request.ownerCode === ""
            || request.supplierType === ""
            || request.supplierCode === ""
            || request.supplierSubCode === ""
            || request.materialItemNumber === ""
            || request.colorCode === "") return;

        const requestState = getMaterialSelectionRequestState(rowNode);
        const requestNo = ++requestState.cost;
        props.fnc.current.postaxios(
            'RawSupplyIn/GetMaterialCostInfo',
            { data: request },
            {
                onSuccess: function (data) {
                    if (!isCurrentMaterialCostRequest(
                        targetRefs,
                        rowNode,
                        sourceRowId,
                        request,
                        requestNo
                    )) return;
                    if (data.rowdata === null || data.rowdata === undefined) {
                        dispatch(warnmsg("素材原価を取得できません。"));
                        return;
                    }

                    const cost = data.rowdata.ZSKM_HEIKINTANKA ?? "";
                    rowNode.data.ZSKM_HEIKINTANKA = cost;
                    const rateUnavailable = applyInitialMaterialUnitPrice(
                        rowNode.data,
                        cost,
                        request,
                        unitPriceContext
                    );
                    const refreshColumns = [
                        "ZSKM_HEIKINTANKA",
                        YEN_UNIT_PRICE_COLUMN,
                        FOREIGN_CURRENCY_UNIT_PRICE_COLUMN,
                    ];
                    let amountCalculated = true;
                    if (request.referenceType === "") {
                        amountCalculated = calculateDetailAmounts(
                            rowNode.data,
                            TOTAL_DETAIL_SUMMARY_TYPES["111"].quantityColumn,
                            entryData
                        );
                        refreshColumns.push(
                            "ZSKM_KINGAKU",
                            "ZSKM_KINGAKUF",
                            "ZSKM_KINGAKUZ"
                        );
                    }
                    targetRefs.api.refreshCells({
                        rowNodes: [rowNode],
                        columns: refreshColumns,
                        force: true,
                    });
                    if (request.referenceType === "") {
                        if (amountCalculated) {
                            refreshMaterialTotalRows(targetRefs);
                        } else {
                            dispatch(warnmsg("原材料金額の端数設定を取得できません。"));
                        }
                    }
                    if (rateUnavailable) {
                        dispatch(warnmsg("支給単価の換算に必要なレートを取得できません。"));
                    }
                },
                onError: function (data) {
                    if (!isCurrentMaterialCostRequest(
                        targetRefs,
                        rowNode,
                        sourceRowId,
                        request,
                        requestNo
                    )) return;
                    dispatch(warnmsg(
                        normalizeConditionValue(data?.errDescription)
                        || "素材原価を取得できません。"
                    ));
                },
            },
            true
        );
    }

    function getAccessoryCostInfo(targetRefs, rowNode, sourceRowId) {
        const entryData = props.entrydataRef.current || {};
        const request = {
            supplyDate: normalizeConditionValue(entryData.ZSK_SIKYUBI),
            brandCode: normalizeConditionValue(entryData.ZSK_BRDCD),
            ownerCode: normalizeConditionValue(entryData.ZSK_SIKYUMOTOCD),
            supplierType: normalizeConditionValue(rowNode.data.ZSKM_ZAISIIRESAKIKBN),
            supplierCode: normalizeConditionValue(rowNode.data.ZSKM_ZAISIIRESAKICD),
            supplierSubCode: normalizeConditionValue(rowNode.data.ZSKM_ZAISIIRESAKISUBCD),
            accessoryItemNumber: normalizeConditionValue(
                rowNode.data[MATERIAL_ITEM_NUMBER_COLUMN]
            ),
            colorCode: normalizeConditionValue(rowNode.data[MATERIAL_COLOR_COLUMN]),
        };
        const requestContext = {
            ...request,
            makerColorCode: normalizeConditionValue(rowNode.data.ZSKM_MEKERCOLORNO),
            overseasType: normalizeConditionValue(entryData.ZSK_KAIGAIKBN),
            supplyType: normalizeConditionValue(entryData.ZSK_SIKYUKBN),
            currencyUnit: normalizeConditionValue(entryData.ZSK_TSUKATANI),
            exchangeRate: normalizeConditionValue(entryData.ZSK_SHANAIRATE),
            referenceType: normalizeConditionValue(entryData.ZSK_SANMOTODENKBN),
        };
        const requestNo = invalidateAccessoryCostRequest(rowNode);
        if (request.supplyDate === ""
            || request.brandCode === ""
            || request.ownerCode === ""
            || request.supplierType === ""
            || request.supplierCode === ""
            || request.supplierSubCode === ""
            || request.accessoryItemNumber === ""
            || request.colorCode === ""
            || requestContext.referenceType !== "") return;

        props.fnc.current.postaxios(
            'RawSupplyIn/GetAccessoryCostInfo',
            { data: request },
            {
                onSuccess: function (data) {
                    if (!isCurrentAccessoryCostRequest(
                        targetRefs,
                        rowNode,
                        sourceRowId,
                        requestContext,
                        requestNo
                    )) return;
                    if (data.rowdata === null || data.rowdata === undefined) {
                        dispatch(warnmsg("附属原価を取得できません。"));
                        return;
                    }

                    const cost = data.rowdata.ZSKM_HEIKINTANKA ?? "";
                    rowNode.data.ZSKM_HEIKINTANKA = cost;
                    const rateUnavailable = applyInitialMaterialUnitPrice(
                        rowNode.data,
                        cost,
                        requestContext,
                        {
                            baseForeignUnitPrice:
                                data.rowdata.INITIAL_FOREIGN_UNIT_PRICE ?? 0,
                            supplyUpliftRate: data.rowdata.SUPPLY_UPLIFT_RATE ?? 0,
                        }
                    );
                    const amountCalculated = calculateDetailAmounts(
                        rowNode.data,
                        TOTAL_DETAIL_SUMMARY_TYPES["121"].quantityColumn,
                        entryData
                    );
                    targetRefs.api.refreshCells({
                        rowNodes: [rowNode],
                        columns: ["ZSKM_HEIKINTANKA", ...DETAIL_AMOUNT_COLUMNS],
                        force: true,
                    });
                    if (amountCalculated) {
                        refreshAccessoryTotalRows(targetRefs);
                    } else {
                        dispatch(warnmsg("原材料金額の端数設定を取得できません。"));
                    }
                    if (rateUnavailable) {
                        dispatch(warnmsg("支給単価の換算に必要なレートを取得できません。"));
                    }
                },
                onError: function (data) {
                    if (!isCurrentAccessoryCostRequest(
                        targetRefs,
                        rowNode,
                        sourceRowId,
                        requestContext,
                        requestNo
                    )) return;
                    dispatch(warnmsg(
                        normalizeConditionValue(data?.errDescription)
                        || "附属原価を取得できません。"
                    ));
                },
            },
            true
        );
    }

    function getSubmaterialCostInfo(targetRefs, rowNode, sourceRowId, requestNo) {
        const entryData = props.entrydataRef.current || {};
        const request = {
            supplyDate: normalizeConditionValue(entryData.ZSK_SIKYUBI),
            brandCode: normalizeConditionValue(entryData.ZSK_BRDCD),
            ownerCode: normalizeConditionValue(entryData.ZSK_SIKYUMOTOCD),
            supplierType: normalizeConditionValue(rowNode.data.ZSKM_ZAISIIRESAKIKBN),
            supplierCode: normalizeConditionValue(rowNode.data.ZSKM_ZAISIIRESAKICD),
            supplierSubCode: normalizeConditionValue(rowNode.data.ZSKM_ZAISIIRESAKISUBCD),
            submaterialItemNumber: normalizeConditionValue(
                rowNode.data[MATERIAL_ITEM_NUMBER_COLUMN]
            ),
            colorCode: normalizeConditionValue(
                rowNode.data[MATERIAL_COLOR_COLUMN]
            ),
        };
        const requestContext = {
            ...request,
            overseasType: normalizeConditionValue(entryData.ZSK_KAIGAIKBN),
            supplyType: normalizeConditionValue(entryData.ZSK_SIKYUKBN),
            currencyUnit: normalizeConditionValue(entryData.ZSK_TSUKATANI),
            exchangeRate: normalizeConditionValue(entryData.ZSK_SHANAIRATE),
            referenceType: normalizeConditionValue(entryData.ZSK_SANMOTODENKBN),
        };
        if (request.supplyDate === ""
            || request.brandCode === ""
            || request.ownerCode === ""
            || request.supplierType === ""
            || request.supplierCode === ""
            || request.supplierSubCode === ""
            || request.submaterialItemNumber === ""
            || requestContext.referenceType !== "") return;

        props.fnc.current.postaxios(
            'RawSupplyIn/GetSubmaterialCostInfo',
            { data: request },
            {
                onSuccess: function (data) {
                    if (!isCurrentSubmaterialCostRequest(
                        targetRefs,
                        rowNode,
                        sourceRowId,
                        requestContext,
                        requestNo
                    )) return;
                    if (data.rowdata === null || data.rowdata === undefined) {
                        dispatch(warnmsg("副資材原価を取得できません。"));
                        return;
                    }

                    const cost = data.rowdata.ZSKM_HEIKINTANKA ?? "";
                    rowNode.data.ZSKM_HEIKINTANKA = cost;
                    const rateUnavailable = applyInitialMaterialUnitPrice(
                        rowNode.data,
                        cost,
                        requestContext,
                        {
                            baseForeignUnitPrice:
                                data.rowdata.INITIAL_FOREIGN_UNIT_PRICE ?? 0,
                            supplyUpliftRate: data.rowdata.SUPPLY_UPLIFT_RATE ?? 0,
                        }
                    );
                    const amountCalculated = calculateDetailAmounts(
                        rowNode.data,
                        TOTAL_DETAIL_SUMMARY_TYPES["131"].quantityColumn,
                        entryData
                    );
                    targetRefs.api.refreshCells({
                        rowNodes: [rowNode],
                        columns: ["ZSKM_HEIKINTANKA", ...DETAIL_AMOUNT_COLUMNS],
                        force: true,
                    });
                    if (amountCalculated) {
                        refreshSubmaterialTotalRows(targetRefs);
                    } else {
                        dispatch(warnmsg("原材料金額の端数設定を取得できません。"));
                    }
                    if (rateUnavailable) {
                        dispatch(warnmsg("支給単価の換算に必要なレートを取得できません。"));
                    }
                },
                onError: function (data) {
                    if (!isCurrentSubmaterialCostRequest(
                        targetRefs,
                        rowNode,
                        sourceRowId,
                        requestContext,
                        requestNo
                    )) return;
                    dispatch(warnmsg(
                        normalizeConditionValue(data?.errDescription)
                        || "副資材原価を取得できません。"
                    ));
                },
            },
            true
        );
    }

    function handleDetailSearchResultApplied(payload) {
        const columnInfo = payload?.columnInfo;
        const columnId = normalizeConditionValue(columnInfo?.columnid).toUpperCase();
        const panelType = normalizeConditionValue(columnInfo?.type);
        const materialSearch = panelType === MATERIAL_DETAIL_PANEL_TYPE
            && (columnId === MATERIAL_ITEM_NUMBER_COLUMN
                || columnId === MATERIAL_COLOR_COLUMN);
        const accessoryItemSearch = panelType === ACCESSORY_DETAIL_PANEL_TYPE
            && columnId === MATERIAL_ITEM_NUMBER_COLUMN;
        const accessoryColorSearch = panelType === ACCESSORY_DETAIL_PANEL_TYPE
            && columnId === MATERIAL_COLOR_COLUMN;
        const submaterialItemSearch = panelType === SUBMATERIAL_DETAIL_PANEL_TYPE
            && columnId === MATERIAL_ITEM_NUMBER_COLUMN;
        const submaterialColorSearch = panelType === SUBMATERIAL_DETAIL_PANEL_TYPE
            && columnId === MATERIAL_COLOR_COLUMN;
        if (!materialSearch
            && !accessoryItemSearch
            && !accessoryColorSearch
            && !submaterialItemSearch
            && !submaterialColorSearch) return;
        if (!Array.isArray(payload?.selectedRows) || payload.selectedRows.length === 0) return;

        const selectedRow = payload.selectedRows[0];
        if (selectedRow === null || selectedRow === undefined) return;

        let sourceRowIds = Array.isArray(payload.sourceRowIds)
            ? payload.sourceRowIds.filter(sourceRowId =>
                normalizeConditionValue(sourceRowId) !== ""
            )
            : [];
        if (sourceRowIds.length === 0
            && normalizeConditionValue(payload.currentRowId) !== "") {
            sourceRowIds = [payload.currentRowId];
        }
        if (sourceRowIds.length === 0) return;

        const candidateGridRefs = panelType === ACCESSORY_DETAIL_PANEL_TYPE
            ? materialPanels
                .filter(panel => panel.type === ACCESSORY_DETAIL_PANEL_TYPE)
                .map(panel => {
                    const detailKey = panel.id + "_" + panel.type + "_"
                        + props.entryDetailResetKey;
                    return gridRefs.current[detailKey];
                })
                .filter(refs => refs !== null && refs !== undefined)
            : panelType === SUBMATERIAL_DETAIL_PANEL_TYPE
                ? materialPanels
                    .filter(panel => panel.type === SUBMATERIAL_DETAIL_PANEL_TYPE)
                    .map(panel => {
                        const detailKey = panel.id + "_" + panel.type + "_"
                            + props.entryDetailResetKey;
                        return gridRefs.current[detailKey];
                    })
                    .filter(refs => refs !== null && refs !== undefined)
            : Object.values(gridRefs.current);

        sourceRowIds.forEach(sourceRowId => {
            if (normalizeConditionValue(sourceRowId).toUpperCase() === "TOTAL") return;

            let targetRefs;
            let rowNode;
            candidateGridRefs.some(refs => {
                const api = refs?.api;
                if (api === null || api === undefined) return false;
                if (typeof api.isDestroyed === "function" && api.isDestroyed()) return false;

                const node = api.getRowNode(sourceRowId);
                if (node === null || node === undefined) return false;

                targetRefs = refs;
                rowNode = node;
                return true;
            });
            if (rowNode?.data === null || rowNode?.data === undefined) return;

            if (accessoryColorSearch) {
                const colorCode = normalizeConditionValue(selectedRow.FZKC_FCOLORCD);
                if (colorCode === "") return;

                ACCESSORY_COLOR_CLEAR_COLUMNS.forEach(targetColumn => {
                    rowNode.data[targetColumn] = "";
                });
                rowNode.setDataValue(MATERIAL_COLOR_COLUMN, colorCode);
                rowNode.setDataValue(MATERIAL_COLOR_COLUMN + "_cd", colorCode);
                rowNode.setDataValue(
                    MATERIAL_COLOR_COLUMN + "_nm",
                    normalizeConditionValue(selectedRow.FZKC_FCOLORNM)
                );
                rowNode.data.ZSKM_MEKERCOLORNO = normalizeConditionValue(
                    selectedRow.FZKC_SIRE_COLORCD
                );
                rowNode.data.ZSKM_MEKERCOLORNO_nm = normalizeConditionValue(
                    selectedRow.FZKC_SIRE_COLORNM
                );
                targetRefs.api.refreshCells({
                    rowNodes: [rowNode],
                    columns: [
                        MATERIAL_COLOR_COLUMN,
                        MATERIAL_COLOR_COLUMN + "_cd",
                        MATERIAL_COLOR_COLUMN + "_nm",
                        "ZSKM_MEKERCOLORNO",
                        "ZSKM_MEKERCOLORNO_nm",
                        ...ACCESSORY_COLOR_CLEAR_COLUMNS,
                    ],
                    force: true,
                });
                refreshAccessoryTotalRows(targetRefs);
                getAccessoryCostInfo(targetRefs, rowNode, sourceRowId);
                return;
            }

            if (submaterialColorSearch) {
                const colorCode = normalizeConditionValue(selectedRow.FZKC_FCOLORCD);
                if (colorCode === "") return;

                const requestNo = invalidateSubmaterialCostRequest(rowNode);
                SUBMATERIAL_COLOR_CLEAR_COLUMNS.forEach(targetColumn => {
                    rowNode.data[targetColumn] = "";
                });
                rowNode.setDataValue(MATERIAL_COLOR_COLUMN, colorCode);
                rowNode.setDataValue(MATERIAL_COLOR_COLUMN + "_cd", colorCode);
                rowNode.setDataValue(
                    MATERIAL_COLOR_COLUMN + "_nm",
                    normalizeConditionValue(selectedRow.FZKC_FCOLORNM)
                );
                rowNode.data.ZSKM_MEKERCOLORNO = normalizeConditionValue(
                    selectedRow.FZKC_SIRE_COLORCD
                );
                rowNode.data.ZSKM_MEKERCOLORNO_nm = normalizeConditionValue(
                    selectedRow.FZKC_SIRE_COLORNM
                );
                targetRefs.api.refreshCells({
                    rowNodes: [rowNode],
                    columns: [
                        MATERIAL_COLOR_COLUMN,
                        MATERIAL_COLOR_COLUMN + "_cd",
                        MATERIAL_COLOR_COLUMN + "_nm",
                        "ZSKM_MEKERCOLORNO",
                        "ZSKM_MEKERCOLORNO_nm",
                        ...SUBMATERIAL_COLOR_CLEAR_COLUMNS,
                    ],
                    force: true,
                });
                refreshSubmaterialTotalRows(targetRefs);
                getSubmaterialCostInfo(targetRefs, rowNode, sourceRowId, requestNo);
                return;
            }

            if (accessoryItemSearch) {
                const appliedItemNumber = normalizeConditionValue(
                    rowNode.data[MATERIAL_ITEM_NUMBER_COLUMN]
                );
                const selectedItemNumber = normalizeConditionValue(
                    selectedRow.FZK_FUZOKU_HINBAN
                );
                if (appliedItemNumber === ""
                    || selectedItemNumber === ""
                    || appliedItemNumber !== selectedItemNumber) return;

                invalidateAccessoryCostRequest(rowNode);
                ACCESSORY_SELECTION_CLEAR_COLUMNS.forEach(targetColumn => {
                    rowNode.data[targetColumn] = "";
                });
                rowNode.data.ZSKM_ZAISIIRESAKIKBN = normalizeConditionValue(
                    selectedRow.FZK_TORKUBUN
                );
                rowNode.data.ZSKM_ZAISIIRESAKISUBCD = normalizeConditionValue(
                    selectedRow.FZK_TORSUBCODE
                );
                rowNode.data.FZK_SIREFUZOKU_HBN = normalizeConditionValue(
                    selectedRow.FZK_SIREFUZOKU_HBN
                );
                rowNode.data.FZK_FUZOKU_SIZE = normalizeConditionValue(
                    selectedRow.FZK_FUZOKU_SIZE
                );
                rowNode.data.FZK_SIREFUZOKU_SIZE = normalizeConditionValue(
                    selectedRow.FZK_SIREFUZOKU_SIZE
                );
                rowNode.data.ZSKM_ZAISIZECD = "*";

                const supplierCode = normalizeConditionValue(selectedRow.FZK_TORCODE);
                rowNode.data[MATERIAL_SUPPLIER_CODE_COLUMN] = "";
                rowNode.setDataValue(MATERIAL_SUPPLIER_CODE_COLUMN, supplierCode);
                rowNode.setDataValue(
                    "ZSKM_TANI",
                    normalizeConditionValue(selectedRow.FZK_TANI)
                );
                targetRefs.api.refreshCells({
                    rowNodes: [rowNode],
                    columns: [
                        "ZSKM_ZAISIIRESAKIKBN",
                        MATERIAL_SUPPLIER_CODE_COLUMN,
                        "ZSKM_ZAISIIRESAKISUBCD",
                        "FZK_SIREFUZOKU_HBN",
                        "FZK_FUZOKU_SIZE",
                        "FZK_SIREFUZOKU_SIZE",
                        "ZSKM_ZAISIZECD",
                        "ZSKM_TANI",
                        ...ACCESSORY_SELECTION_CLEAR_COLUMNS,
                    ],
                    force: true,
                });
                refreshAccessoryTotalRows(targetRefs);
                return;
            }

            if (submaterialItemSearch) {
                const appliedItemNumber = normalizeConditionValue(
                    rowNode.data[MATERIAL_ITEM_NUMBER_COLUMN]
                );
                const selectedItemNumber = normalizeConditionValue(
                    selectedRow.FZK_FUZOKU_HINBAN
                );
                if (appliedItemNumber === ""
                    || selectedItemNumber === ""
                    || appliedItemNumber !== selectedItemNumber) return;

                const requestNo = invalidateSubmaterialCostRequest(rowNode);
                SUBMATERIAL_SELECTION_CLEAR_COLUMNS.forEach(targetColumn => {
                    rowNode.data[targetColumn] = "";
                });
                rowNode.data.ZSKM_ZAISIIRESAKIKBN = normalizeConditionValue(
                    selectedRow.FZK_TORKUBUN
                );
                rowNode.data.ZSKM_ZAISIIRESAKISUBCD = normalizeConditionValue(
                    selectedRow.FZK_TORSUBCODE
                );
                rowNode.data.FZK_SIREFUZOKU_HBN = normalizeConditionValue(
                    selectedRow.FZK_SIREFUZOKU_HBN
                );
                rowNode.data.ZSKM_ZAISIZECD = "*";

                const supplierCode = normalizeConditionValue(selectedRow.FZK_TORCODE);
                rowNode.data[MATERIAL_SUPPLIER_CODE_COLUMN] = "";
                rowNode.setDataValue(MATERIAL_SUPPLIER_CODE_COLUMN, supplierCode);
                rowNode.setDataValue(
                    "ZSKM_TANI",
                    normalizeConditionValue(selectedRow.FZK_TANI)
                );
                targetRefs.api.refreshCells({
                    rowNodes: [rowNode],
                    columns: [
                        "ZSKM_ZAISIIRESAKIKBN",
                        MATERIAL_SUPPLIER_CODE_COLUMN,
                        "ZSKM_ZAISIIRESAKISUBCD",
                        "FZK_SIREFUZOKU_HBN",
                        "ZSKM_ZAISIZECD",
                        "ZSKM_TANI",
                        ...SUBMATERIAL_SELECTION_CLEAR_COLUMNS,
                    ],
                    force: true,
                });
                refreshSubmaterialTotalRows(targetRefs);
                getSubmaterialCostInfo(targetRefs, rowNode, sourceRowId, requestNo);
                return;
            }

            if (columnId === MATERIAL_COLOR_COLUMN) {
                const colorCode = normalizeConditionValue(selectedRow.ZAIC_COLORCD);
                if (colorCode === "") return;
                const currentMakerColorCode = normalizeConditionValue(
                    rowNode.data.ZSKM_MEKERCOLORNO
                );
                const requestState = getMaterialSelectionRequestState(rowNode);
                ++requestState.cost;

                rowNode.setDataValue(MATERIAL_COLOR_COLUMN, colorCode);
                rowNode.setDataValue(MATERIAL_COLOR_COLUMN + "_cd", colorCode);
                rowNode.setDataValue(
                    MATERIAL_COLOR_COLUMN + "_nm",
                    normalizeConditionValue(selectedRow.ZAIC_COLORNM)
                );
                MATERIAL_COLOR_CLEAR_COLUMNS.forEach(targetColumn => {
                    rowNode.data[targetColumn] = "";
                });
                targetRefs.api.refreshCells({
                    rowNodes: [rowNode],
                    columns: [
                        MATERIAL_COLOR_COLUMN,
                        MATERIAL_COLOR_COLUMN + "_cd",
                        MATERIAL_COLOR_COLUMN + "_nm",
                        ...MATERIAL_COLOR_CLEAR_COLUMNS,
                    ],
                    force: true,
                });
                refreshMaterialTotalRows(targetRefs);
                getMaterialSelectionInfo(
                    targetRefs,
                    rowNode,
                    sourceRowId,
                    "color",
                    currentMakerColorCode
                );
                return;
            }

            const appliedItemNumber = normalizeConditionValue(
                rowNode.data[MATERIAL_ITEM_NUMBER_COLUMN]
            );
            const selectedItemNumber = normalizeConditionValue(selectedRow.ZAI_HINBAN);
            if (appliedItemNumber !== ""
                && selectedItemNumber !== ""
                && appliedItemNumber !== selectedItemNumber) return;

            MATERIAL_SELECTION_FIELD_MAP.forEach(([sourceColumn, targetColumn]) => {
                rowNode.data[targetColumn] = normalizeConditionValue(selectedRow[sourceColumn]);
            });

            const supplierCode = normalizeConditionValue(selectedRow.ZAI_TORCODE);
            if (normalizeConditionValue(rowNode.data[MATERIAL_SUPPLIER_CODE_COLUMN])
                !== supplierCode) {
                rowNode.setDataValue(MATERIAL_SUPPLIER_CODE_COLUMN, supplierCode);
            }
            const requestState = getMaterialSelectionRequestState(rowNode);
            ++requestState.color;
            ++requestState.cost;
            MATERIAL_SELECTION_CLEAR_COLUMNS.forEach(targetColumn => {
                rowNode.data[targetColumn] = "";
            });
            targetRefs.api.refreshCells({
                rowNodes: [rowNode],
                columns: [
                    MATERIAL_MAKER_ITEM_NUMBER_COLUMN,
                    MATERIAL_SUPPLIER_CODE_COLUMN,
                    ...MATERIAL_SELECTION_CLEAR_COLUMNS,
                ],
                force: true,
            });
            refreshMaterialTotalRows(targetRefs);
            getMaterialSelectionInfo(targetRefs, rowNode, sourceRowId, "material", "");
        });
    }

    function handleDirectDetailMasterValueChanged(params, panel, targetRefs) {
        const eventSource = normalizeConditionValue(params?.source).toLowerCase();
        if (eventSource !== "edit" && eventSource !== "paste") return false;

        const entryData = props.entrydataRef.current || {};
        if (normalizeConditionValue(entryData.ZSK_SANMOTODENKBN) !== "") return false;

        const panelType = normalizeConditionValue(panel?.type);
        const columnId = normalizeConditionValue(params?.column?.colId).toUpperCase();
        const itemOrSupplierChanged = columnId === MATERIAL_ITEM_NUMBER_COLUMN
            || columnId === MATERIAL_SUPPLIER_CODE_COLUMN;
        const colorChanged = columnId === MATERIAL_COLOR_COLUMN;
        if (!itemOrSupplierChanged && !colorChanged) return false;
        if (panelType !== MATERIAL_DETAIL_PANEL_TYPE
            && panelType !== ACCESSORY_DETAIL_PANEL_TYPE
            && panelType !== SUBMATERIAL_DETAIL_PANEL_TYPE) return false;

        const rowNode = params?.node;
        if (rowNode?.data === null || rowNode?.data === undefined) return true;
        const sourceRowId = normalizeConditionValue(rowNode.id ?? rowNode.data.rowid);
        if (sourceRowId === "" || sourceRowId.toUpperCase() === "TOTAL") return true;
        rowNode.data.ZSKM_ZAISIIRESAKIKBN = "1";
        rowNode.data.ZSKM_ZAISIIRESAKISUBCD = "00000";

        if (panelType === MATERIAL_DETAIL_PANEL_TYPE) {
            const requestState = getMaterialSelectionRequestState(rowNode);
            if (itemOrSupplierChanged) {
                ++requestState.material;
                ++requestState.color;
                ++requestState.cost;
                DIRECT_MATERIAL_SELECTION_CLEAR_COLUMNS.forEach(targetColumn => {
                    rowNode.data[targetColumn] = "";
                });
                targetRefs.api.refreshCells({
                    rowNodes: [rowNode],
                    columns: DIRECT_MATERIAL_SELECTION_CLEAR_COLUMNS,
                    force: true,
                });
                refreshMaterialTotalRows(targetRefs);

                const requiredKeys = [
                    entryData.ZSK_BRDCD,
                    rowNode.data.ZSKM_ZAISIIRESAKICD,
                    rowNode.data[MATERIAL_ITEM_NUMBER_COLUMN],
                ];
                if (requiredKeys.every(value => normalizeConditionValue(value) !== "")) {
                    getMaterialSelectionInfo(
                        targetRefs,
                        rowNode,
                        sourceRowId,
                        "material",
                        ""
                    );
                }
                return true;
            }

            ++requestState.color;
            ++requestState.cost;
            rowNode.data[MATERIAL_COLOR_COLUMN + "_cd"] =
                normalizeConditionValue(rowNode.data[MATERIAL_COLOR_COLUMN]);
            rowNode.data[MATERIAL_COLOR_COLUMN + "_nm"] = "";
            MATERIAL_COLOR_CLEAR_COLUMNS.forEach(targetColumn => {
                rowNode.data[targetColumn] = "";
            });
            targetRefs.api.refreshCells({
                rowNodes: [rowNode],
                columns: [
                    MATERIAL_COLOR_COLUMN,
                    MATERIAL_COLOR_COLUMN + "_cd",
                    MATERIAL_COLOR_COLUMN + "_nm",
                    ...MATERIAL_COLOR_CLEAR_COLUMNS,
                ],
                force: true,
            });
            refreshMaterialTotalRows(targetRefs);

            const colorCode = normalizeConditionValue(
                rowNode.data[MATERIAL_COLOR_COLUMN]
            );
            const requiredKeys = [
                entryData.ZSK_BRDCD,
                rowNode.data.ZSKM_ZAISIIRESAKICD,
                rowNode.data[MATERIAL_ITEM_NUMBER_COLUMN],
                colorCode,
            ];
            if (requiredKeys.every(value => normalizeConditionValue(value) !== "")) {
                getMaterialSelectionInfo(
                    targetRefs,
                    rowNode,
                    sourceRowId,
                    "color",
                    ""
                );
            }
            return true;
        }

        const requestState = getFzkSelectionRequestState(rowNode);
        if (itemOrSupplierChanged) {
            ++requestState.item;
            ++requestState.color;
            if (panelType === ACCESSORY_DETAIL_PANEL_TYPE) {
                invalidateAccessoryCostRequest(rowNode);
            } else {
                invalidateSubmaterialCostRequest(rowNode);
            }
            FZK_SELECTION_CLEAR_COLUMNS.forEach(targetColumn => {
                rowNode.data[targetColumn] = "";
            });
            targetRefs.api.refreshCells({
                rowNodes: [rowNode],
                columns: FZK_SELECTION_CLEAR_COLUMNS,
                force: true,
            });
            if (panelType === ACCESSORY_DETAIL_PANEL_TYPE) {
                refreshAccessoryTotalRows(targetRefs);
            } else {
                refreshSubmaterialTotalRows(targetRefs);
            }

            const requiredKeys = [
                entryData.ZSK_BRDCD,
                rowNode.data.ZSKM_ZAISIIRESAKICD,
                rowNode.data[MATERIAL_ITEM_NUMBER_COLUMN],
            ];
            if (requiredKeys.every(value => normalizeConditionValue(value) !== "")) {
                getFzkSelectionInfo(
                    targetRefs,
                    rowNode,
                    sourceRowId,
                    panelType,
                    "item"
                );
            }
            return true;
        }

        ++requestState.color;
        const colorCode = normalizeConditionValue(rowNode.data[MATERIAL_COLOR_COLUMN]);
        rowNode.data[MATERIAL_COLOR_COLUMN + "_cd"] = colorCode;
        FZK_COLOR_CLEAR_COLUMNS.forEach(targetColumn => {
            rowNode.data[targetColumn] = "";
        });
        const refreshColumns = [
            MATERIAL_COLOR_COLUMN,
            MATERIAL_COLOR_COLUMN + "_cd",
            ...FZK_COLOR_CLEAR_COLUMNS,
        ];
        let submaterialCostRequestNo;
        if (panelType === ACCESSORY_DETAIL_PANEL_TYPE) {
            invalidateAccessoryCostRequest(rowNode);
            ACCESSORY_COLOR_CLEAR_COLUMNS.forEach(targetColumn => {
                rowNode.data[targetColumn] = "";
            });
            refreshColumns.push(...ACCESSORY_COLOR_CLEAR_COLUMNS);
        } else {
            submaterialCostRequestNo = invalidateSubmaterialCostRequest(rowNode);
            SUBMATERIAL_COLOR_CLEAR_COLUMNS.forEach(targetColumn => {
                rowNode.data[targetColumn] = "";
            });
            refreshColumns.push(...SUBMATERIAL_COLOR_CLEAR_COLUMNS);
        }
        targetRefs.api.refreshCells({
            rowNodes: [rowNode],
            columns: refreshColumns,
            force: true,
        });
        if (panelType === ACCESSORY_DETAIL_PANEL_TYPE) {
            refreshAccessoryTotalRows(targetRefs);
        } else {
            refreshSubmaterialTotalRows(targetRefs);
        }

        const requiredKeys = [
            entryData.ZSK_BRDCD,
            rowNode.data.ZSKM_ZAISIIRESAKICD,
            rowNode.data[MATERIAL_ITEM_NUMBER_COLUMN],
        ];
        if (colorCode === "") {
            if (panelType === SUBMATERIAL_DETAIL_PANEL_TYPE
                && requiredKeys.every(value => normalizeConditionValue(value) !== "")) {
                getSubmaterialCostInfo(
                    targetRefs,
                    rowNode,
                    sourceRowId,
                    submaterialCostRequestNo
                );
            }
            return true;
        }
        if (requiredKeys.every(value => normalizeConditionValue(value) !== "")) {
            getFzkSelectionInfo(
                targetRefs,
                rowNode,
                sourceRowId,
                panelType,
                "color"
            );
        }
        return true;
    }

    function detailValueChanged(params, panel, refs, totalRefs, totalType) {
        if (handleDirectDetailMasterValueChanged(params, panel, refs)) return;

        const columnId = normalizeConditionValue(params?.column?.colId).toUpperCase();
        const summaryType = Object.values(TOTAL_DETAIL_SUMMARY_TYPES).find(
            summary => summary.detail === panel.type
        );
        if (summaryType === undefined
            || (columnId !== summaryType.quantityColumn
                && columnId !== YEN_UNIT_PRICE_COLUMN
                && columnId !== FOREIGN_CURRENCY_UNIT_PRICE_COLUMN)) return;

        const entryData = props.entrydataRef.current || {};
        const materialQuantityChanged = panel.type === MATERIAL_DETAIL_PANEL_TYPE
            && columnId === summaryType.quantityColumn;
        if (materialQuantityChanged) calculateMaterialSupplyRollCount(params.data);

        let convertedUnitPrice = false;
        if (columnId === YEN_UNIT_PRICE_COLUMN
            || columnId === FOREIGN_CURRENCY_UNIT_PRICE_COLUMN) {
            const currencyUnit = normalizeConditionValue(entryData.ZSK_TSUKATANI).toUpperCase();
            const rateValue = normalizeConditionValue(entryData.ZSK_SHANAIRATE);
            const rate = Number(rateValue);
            if (currencyUnit !== ""
                && currencyUnit !== "JPY"
                && rateValue !== ""
                && Number.isFinite(rate)
                && rate > 0) {
                if (columnId === YEN_UNIT_PRICE_COLUMN) {
                    params.data[FOREIGN_CURRENCY_UNIT_PRICE_COLUMN] =
                        GetDesitRound(NumConv(params.newValue) / rate, 1, 2);
                } else {
                    params.data[YEN_UNIT_PRICE_COLUMN] =
                        GetDesitRound(NumConv(params.newValue) * rate, 1, 2);
                }
                convertedUnitPrice = true;
            }
        }

        if (!calculateDetailAmounts(params.data, summaryType.quantityColumn, entryData)) {
            if (convertedUnitPrice || materialQuantityChanged) {
                const refreshColumns = convertedUnitPrice ? [...DETAIL_AMOUNT_COLUMNS] : [];
                if (materialQuantityChanged) refreshColumns.push("ZSKM_SIKYUTANSU");
                params.api.refreshCells({
                    rowNodes: [params.node],
                    columns: refreshColumns,
                    force: true,
                });
            }
            dispatch(warnmsg("原材料金額の端数設定を取得できません。"));
            return;
        }

        const refreshColumns = [...DETAIL_AMOUNT_COLUMNS];
        if (materialQuantityChanged) refreshColumns.push("ZSKM_SIKYUTANSU");
        params.api.refreshCells({
            rowNodes: [params.node],
            columns: refreshColumns,
            force: true,
        });

        if (totalType === "") return;
        totalRefs.dataRef.current = buildTotalRows(totalType, refs.dataRef.current);
        props.fnc.current.rerenderGrid(props.fnc.current.GridID("T" + panel.id));
    }

    function getGridRefs(key, data) {
        if (!(key in gridRefs.current)) {
            gridRefs.current[key] = {
                dataRef: { current: data },
                columnRef: { current: null },
                api: null,
            };
        }
        return gridRefs.current[key];
    }

    function getDetailRows(type) {
        const detail = props.detail === null || props.detail === undefined
            ? {}
            : props.detail;
        return Array.isArray(detail[type]) ? detail[type] : null;
    }

    function buildTotalRows(type, detailRows) {
        const totalRow = { rowid: "TOTAL", grip: "計" };
        const entryData = props.entrydataRef.current || {};
        columnInfo.filter(column => column.type === type).forEach(column => {
            if (column.columnid in entryData) {
                totalRow[column.columnid] = entryData[column.columnid];
            }
        });

        const summaryType = TOTAL_DETAIL_SUMMARY_TYPES[type];
        if (summaryType === undefined) return [totalRow];

        const currentRows = Array.isArray(detailRows) ? detailRows : [];
        const taxAmountValue = entryData.ZSK_ZEIGAKU ?? "";
        const taxAmount = NumConv(taxAmountValue);
        const amount = sumRawSupplyValues(currentRows, "ZSKM_KINGAKUZ");
        totalRow.ZSK_QTY_T = sumRawSupplyValues(currentRows, summaryType.quantityColumn);
        totalRow.ZSK_ZEIGAKU = taxAmountValue;
        totalRow.ZSK_AMT_T = amount;
        totalRow.ZSK_TAXIN_T = amount + taxAmount;
        totalRow.ZSK_FCURRENCY_T = sumRawSupplyValues(currentRows, "ZSKM_KINGAKUF");
        return [totalRow];
    }

    function getTotalRows(type) {
        const rows = getDetailRows(type);
        if (rows !== null && rows.length !== 0) return rows;

        const summaryType = TOTAL_DETAIL_SUMMARY_TYPES[type];
        return buildTotalRows(
            type,
            summaryType === undefined ? [] : getDetailRows(summaryType.detail)
        );
    }

    function getTotalType(panel) {
        const total = columnInfo.find(column =>
            column.logpid === "T" + panel.id && column.type === activePanelTypes.total
        );
        return total === undefined ? "" : total.type;
    }

    function queryDetailAddRow() {
        const referenceType = normalizeConditionValue(
            props.entrydataRef.current?.ZSK_SANMOTODENKBN
        );
        if (referenceType !== "1" && referenceType !== "2") return true;

        props.fnc.current.warnmsg("参照元が指定されているため明細行は追加できません。");
        return false;
    }

    function updatePanels(nextPanels) {
        if (typeof props.setPanels !== "function") return;
        props.setPanels(nextPanels);
    }

    function panelAvailable(panel) {
        if (panel.id === "0") return textFields.some(field => field.type === panel.type);
        return columnInfo.some(column => column.type === panel.type);
    }

    function scrollToPanel(panel) {
        const elementId = panel.id === "0"
            ? "basepanel" + panel.type
            : props.fnc.current.GridID(panel);
        const element = document.getElementById(elementId);
        if (element === null || entryBodyRef.current === null) return;
        entryBodyRef.current.scrollTop = element.offsetTop - 50;
    }

    function showPanel(id, type, show) {
        updatePanels(panels.map(panel => panel.id === id && panel.type === type
            ? { ...panel, hide: !show }
            : panel));
    }

    function setBaseLayout(newColumns, type) {
        const nextFields = textFields.filter(field => field.type !== type);
        newColumns.forEach(columnId => {
            const column = columnInfo.find(item => item.type === type && item.columnid === columnId);
            if (column !== undefined) nextFields.push(column);
        });
        setTextFields(applyRawSupplyHeaderDefinitions(
            nextFields,
            columns,
            props.entrydataRef.current,
            formStatus,
            activeMaterialType
        ));
    }

    function activeGridRefs(type) {
        const detailPanel = materialPanels.find(panel => panel.type === activePanelTypes.detail);
        if (detailPanel === undefined) return null;
        const detailKey = detailPanel.id + "_" + detailPanel.type + "_" + props.entryDetailResetKey;
        if (type === activePanelTypes.detail) return gridRefs.current[detailKey] || null;
        const totalType = getTotalType(detailPanel);
        const totalKey = "T" + detailPanel.id + "_" + totalType + "_" + props.entryDetailResetKey;
        return type === totalType ? gridRefs.current[totalKey] || null : null;
    }

    function currentGridLayout(type) {
        const refs = activeGridRefs(type);
        if (refs === null || refs.api === null) return [];
        const allColumns = refs.api.getAllGridColumns();
        return refs.api.getColumnState()
            .filter(state => !state.hide && state.colId !== "rowid" && state.colId !== "grip")
            .map(state => {
                const gridColumn = allColumns.find(column => column.getColId() === state.colId);
                const info = gridColumn?.getColDef()?.colinfo;
                if (info === undefined) return null;
                return {
                    headerName: info.columnnm,
                    table: info.table,
                    field: state.colId,
                    width: state.width,
                    pinned: state.pinned ? true : false,
                    type: type,
                };
            })
            .filter(item => item !== null);
    }

    function configuredGridLayout(type) {
        return columns.filter(column => column.type === type).map(column => ({
            headerName: column.columnnm,
            table: column.table,
            field: column.columnid,
            width: column.width,
            pinned: column.pinned ? true : false,
            type: type,
        }));
    }

    function saveLayout(layoutId) {
        const layoutColumns = textFields.filter(field => !field.hide).map(field => ({
            headerName: field.columnnm,
            table: field.table,
            field: field.columnid,
            width: field.width,
            type: field.type,
        }));
        Object.values(MATERIAL_PANEL_TYPES).forEach(types => {
            [types.detail, types.total].forEach(type => {
                const current = currentGridLayout(type);
                layoutColumns.push(...(current.length === 0 ? configuredGridLayout(type) : current));
            });
        });
        props.fnc.current.postaxios('common/SaveLayout', {
            controller: props.controller,
            subkey: props.subkey,
            code: layoutId,
            coldef: layoutColumns,
            panels: panels,
        }, {
            onSuccess: function () {
                dispatch(addentrylayout({ value: layoutId, label: layoutId }));
                props.fnc.current.success();
                props.fnc.current.wait(false);
            },
        });
    }

    function deleteLayout(layoutId) {
        props.fnc.current.postaxios('common/DeleteEntryLayout', {
            controller: props.controller,
            subkey: props.subkey,
            code: layoutId,
        }, {
            onSuccess: function (data) {
                const layouts = Array.isArray(mainLayout) ? mainLayout : [];
                dispatch(setentrylayout(layouts.filter(layout => layout.value !== layoutId)));
                if (data.request !== mainInitlayout) {
                    dispatch(setentrystartup({
                        prelayout: mainPrelayout,
                        initlayout: " ",
                        fitColumn: false,
                    }));
                }
                props.fnc.current.success();
                props.fnc.current.wait(false);
            },
        });
    }

    function applyGridLayout(type, loadedColumns) {
        const refs = activeGridRefs(type);
        if (refs === null || refs.api === null) return;
        const target = loadedColumns.filter(column => column.type === type);
        const targetIds = target.map(column => column.columnid);
        const hidden = refs.api.getColumnState()
            .filter(state => state.colId !== "rowid" && state.colId !== "grip" && !targetIds.includes(state.colId))
            .map(state => ({ colId: state.colId, hide: true }));
        const shown = target.map(column => ({
            colId: column.columnid,
            hide: false,
            width: column.width,
            pinned: column.pinned ? column.pinned : null,
        }));
        refs.api.applyColumnState({ state: [...shown, ...hidden], applyOrder: true });
    }

    function callLayout(layoutId) {
        props.fnc.current.postaxios('common/LoadLayout', {
            controller: props.controller,
            subkey: props.subkey,
            code: layoutId,
        }, {
            onSuccess: function (data) {
                const loadedPanels = Array.isArray(data.panels) ? data.panels : [];
                const loadedColumns = Array.isArray(data.columns) ? data.columns : [];
                const loadedTypes = new Set(loadedColumns.map(column => column.type));
                const mergedColumns = [
                    ...columns.filter(column => !loadedTypes.has(column.type)),
                    ...loadedColumns,
                ];
                updatePanels(panels.map(panel => {
                    const loaded = loadedPanels.find(item => item.id === panel.id && item.type === panel.type);
                    return loaded === undefined ? panel : { ...panel, ...loaded };
                }));
                if (typeof props.setColumns === "function") props.setColumns(mergedColumns);
                applyGridLayout(activePanelTypes.detail, mergedColumns);
                applyGridLayout(activePanelTypes.total, mergedColumns);
                props.fnc.current.wait(false);
            },
        });
    }

    function renderDetailGrid(panel) {
        const refs = getGridRefs(
            panel.id + "_" + panel.type + "_" + props.entryDetailResetKey,
            getDetailRows(panel.type)
        );
        const totalType = getTotalType(panel);
        const totalRefs = getGridRefs(
            "T" + panel.id + "_" + totalType + "_" + props.entryDetailResetKey,
            getTotalRows(totalType)
        );
        const totalPanel = { ...panel, totaltype: totalType };

        return (
            <React.Fragment>
                <EntryGridAr
                    key={panel.id + "_" + panel.type + "_" + props.entryDetailResetKey}
                    id={props.fnc.current.GridID(panel)}
                    entrydataRef={props.entrydataRef}
                    dataRef={refs.dataRef}
                    columnRef={refs.columnRef}
                    columninfo={columnInfo}
                    columns={columns}
                    fnc={props.fnc}
                    formid={props.formid}
                    panel={panel}
                    EntrybodyRef={entryBodyRef}
                    QueryAddRow={queryDetailAddRow}
                    onGridReady={(params) => {
                        refs.api = params.api;
                        if (panel.type === activePanelTypes.detail) {
                            tryRefreshCopyCostsRef.current();
                        }
                    }}
                    onFirstDataRendered={() => {
                        if (panel.type === activePanelTypes.detail) {
                            tryRefreshCopyCostsRef.current();
                        }
                    }}
                    lockcell={(params, edit) => rawSupplyDetailCellEditable(
                        params,
                        edit,
                        props.entrydataRef.current,
                        panel.type
                    )}
                    ValueChanged={(params) => detailValueChanged(
                        params,
                        panel,
                        refs,
                        totalRefs,
                        totalType
                    )}
                    SearchResultApplied={handleDetailSearchResultApplied}
                />
                {totalType === "" ? null :
                    <EntryGridAr
                        key={"T" + panel.id + "_" + totalType + "_" + props.entryDetailResetKey}
                        id={props.fnc.current.GridID("T" + panel.id)}
                        entrydataRef={props.entrydataRef}
                        dataRef={totalRefs.dataRef}
                        columnRef={totalRefs.columnRef}
                        columninfo={columnInfo}
                        columns={columns}
                        fnc={props.fnc}
                        formid={props.formid}
                        panel={totalPanel}
                        EntrybodyRef={entryBodyRef}
                        total={true}
                        totaltype={totalType}
                    />
                }
            </React.Fragment>
        );
    }

    function renderContents(panel) {
        if (panel.type === activePanelTypes.detail) return renderDetailGrid(panel);
        const handlesHeaderBlur = panel.type === "102" || textFields.some(
            field => field.type === panel.type && INVOICE_COLUMNS.includes(field.columnid)
        );
        return (
            <div
                id={"basepanel" + panel.type}
                onBlur={handlesHeaderBlur
                    ? event => handleRawSupplyHeaderBlur(event, panel.type)
                    : undefined}
            >
                <EntryBase
                    fnc={props.fnc}
                    textfields={textFields}
                    settextfields={setTextFields}
                    panel={panel}
                    entrydataRef={props.entrydataRef}
                    layoutlock={layoutLock}
                    ValueChanged={valueChanged}
                />
            </div>
        );
    }

    return (
        <div style={{ height: '100%', minHeight: 0, overflow: 'hidden' }}>
            <div style={{ padding: '5px 15px', paddingBottom: '300px', boxSizing: 'border-box', height: '100%', overflow: 'auto', backgroundColor: '#D8D8D8' }} ref={entryBodyRef}>
                {materialPanels.map(panel =>
                    <Box
                        key={panel.id + "_" + panel.type}
                        display={panel.hide || !panelAvailable(panel) ? "none" : "flex"}
                        justifyContent="space-around"
                        alignItems="center"
                        padding="5px"
                    >
                        <Paper style={{ width: '100%', height: 'auto', padding: 10 }}>
                            <div style={{ position: 'relative', marginBottom: 5 }}>
                                {panel.name} - <span style={{ fontStyle: 'oblique' }}>{panel.name2}</span>
                                {panel.id !== "0" || layoutLock ? null :
                                    <div style={{ position: 'absolute', right: 40, top: -3 }} title="項目設定">
                                        <IconButton size="small" onClick={() => props.fnc.current.entrylayoutopen(panel.type)}>
                                            <Icon style={{ fontSize: 16 }}>settings_applications</Icon>
                                        </IconButton>
                                    </div>
                                }
                                {layoutLock || sectionClose ? null :
                                    <div style={{ position: 'absolute', right: 10, top: -3 }}>
                                        <IconButton size="small" onClick={() => showPanel(panel.id, panel.type, false)}>
                                            <Icon style={{ fontSize: 16 }}>close</Icon>
                                        </IconButton>
                                    </div>
                                }
                            </div>
                            {renderContents(panel)}
                        </Paper>
                    </Box>
                )}
            </div>
            <EntryLayout
                columninfo={columnInfo}
                textfields={textFields}
                onAppry={setBaseLayout}
            />
            <EntrySetting
                formid={props.formid}
                controller={props.controller}
                subkey={props.subkey}
                savelayout={saveLayout}
                deletelayout={deleteLayout}
                calllayout={callLayout}
                panels={materialPanels}
                showpanel={showPanel}
            />
        </div>
    );
});

export default RawSupplyInEntry;
